"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9579],{

/***/ 69579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qU": function() { return /* reexport */ useVehicleCount; }
});

// UNUSED EXPORTS: FinanceDrawerContext, FindVehicleResultsCountWrapper, MobileAppFooter, SearchAlertsButton, SearchAlertsDrawer, SearchAlertsForm, SearchStoreProvider, SsrPropsContext, SsrPropsContextProvider, UsedCarsDataTempComponent, VehicleCard, convertFilterValueToUrlSegment, convertRawSearchFiltersToSearchFilters, convertSearchFiltersToQueryParams, csvUtils, extractMappingsFromMakesFacet, formatFilterOptionValue, formatVehicleSpecs, getActiveFilters, getFormattedFuelType, getKeyForValueFromMap, getOrderedParsedFilterMap, getOrderedUrlPathSegmentFilters, getPagetype, getSearchPageTitle, getSessionStorage, getStoryBlokSlug, getStoryblokSlugFromUrl, getTrackingLabel, getUsedCarsApiRequestUrlForUrlPath, getUsedCarsUrlFilterHistoryFromSessionStorage, isWindowUserAgentCinchApp, mapFiltersToUrl, renderWithResolver, sanitisePathSegment, sessionStorageMock, setSessionStorage, setUsedCarsUrlFilterHistoryInSessionStorage, stringLengthChecker, stripNonSearchQueryParametersFromUrl, transformFilterArrayToString, truncateSegmentsToQueryParams, useAutoSuggest, useCinchStores, useDrawer, useFinanceDrawerContext, useLocalStorage, usePagination, useResponsiveEnvironment, useSearchAlertFiltersFormatting, useSearchAlerts, useSearchAlertsDrawer, useSearchFilters, useSearchFiltersFormatting, useSearchResults, useSearchStore, useSsrProps, useStoryblokData, useUsedCarsData

// NAMESPACE OBJECT: ../../../libs/search/shared/src/lib/utils/csv/csv.ts
var csv_namespaceObject = {};
__webpack_require__.r(csv_namespaceObject);
__webpack_require__.d(csv_namespaceObject, {
  "findInCSV": function() { return findInCSV; },
  "isCSV": function() { return isCSV; },
  "makeCSV": function() { return makeCSV; },
  "mapCSV": function() { return mapCSV; },
  "nthCSV": function() { return nthCSV; },
  "parseCSV": function() { return parseCSV; }
});

// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../node_modules/axios/index.js
var axios = __webpack_require__(43653);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../libs/data/search/src/index.ts + 26 modules
var search_src = __webpack_require__(2582);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-local-storage/local-search-data.ts

const hydrate = (data, type)=>data.map(({ label , value  })=>({
            label: `${label} cars`,
            value,
            searchValue: label.toLowerCase(),
            type
        }));
const local_search_data_LocalSearchData = [
    ...hydrate(search_src/* fuelTypesData */.GM, "fuelType"),
    ...hydrate(search_src/* bodyTypesData */.kg, "bodyType"),
    ...hydrate(search_src/* transmissionTypeData */.Xl, "gearbox")
];
/* harmony default export */ var local_search_data = ((/* unused pure expression or super */ null && (local_search_data_LocalSearchData)));

// EXTERNAL MODULE: ../../../node_modules/fastest-levenshtein/esm/mod.js
var mod = __webpack_require__(64946);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-auto-suggest/use-auto-suggest.ts





const httpClient = axios_default().create();
const localSuggestions = (searchTerm)=>{
    const searchTerms = searchTerm.split(/\s+/).filter(Boolean);
    return LocalSearchData.filter((data)=>searchTerms.some((term)=>{
            const searchTermLength = term.length;
            if (term === data.searchValue.slice(0, Math.max(0, searchTermLength))) return true;
            const levenshtein = distance(term ?? "", data.searchValue.slice(0, Math.max(0, searchTermLength)) ?? "");
            if (searchTermLength > 1 && levenshtein === 1) return true;
            return false;
        }));
};
const useAutoSuggest = ()=>{
    const searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    const [fetchStatus, setFetchStatus] = useState("initial");
    const [error, setError] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const getSuggestionResults = async (value, size = "")=>{
        const maxSectionSuggestCount = 5;
        const maxSuggestTotalCount = 10;
        const maxLocalSuggestCount = Math.min(maxSectionSuggestCount, localSuggestions(value).length);
        try {
            setFetchStatus("pending");
            if (value.length === 0) {
                setFetchStatus("initial");
                return;
            }
            const url = `${searchApiUrl}/suggest`;
            const suggestionsResult = await httpClient.get(`${url}?searchTerm=${value}&size=${size}`);
            setSuggestions([
                {
                    title: "Make model trim",
                    suggestions: [
                        ...suggestionsResult.data.suggestions
                    ].slice(0, maxSuggestTotalCount - maxLocalSuggestCount)
                },
                {
                    title: localSuggestions(value).length > 0 ? "Car type" : "",
                    suggestions: [
                        ...localSuggestions(value)
                    ].slice(0, maxLocalSuggestCount)
                }
            ].filter(Boolean));
            setFetchStatus("success");
        } catch (error) {
            setError(error);
            setFetchStatus("error");
        }
    };
    const clearSuggestions = ()=>{
        setSuggestions([
            {
                title: "Make model trim",
                suggestions: []
            }
        ]);
    };
    return {
        fetchStatus,
        error,
        getSuggestionResults,
        suggestions,
        clearSuggestions
    };
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-auto-suggest/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-store/use-search-store.ts


const use_search_store_SearchStoreContext = (0,react.createContext)(null);
const use_search_store_useSearchStore = (selector)=>{
    const store = useContext(use_search_store_SearchStoreContext);
    if (!store) throw new Error("Store is missing the provider");
    return useStore(store, selector);
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-cinch-stores/use-cinch-stores.ts


function use_cinch_stores_useCinchStores() {
    const { allCinchStores , allCinchStoresLowercase  } = useSearchStore(useShallow((state)=>({
            allCinchStores: state.allCinchStores,
            allCinchStoresLowercase: state.allCinchStoresLowercase
        })));
    return {
        isSingleStore: allCinchStores.length === 1,
        allCinchStores: [
            ...allCinchStores
        ],
        allCinchStoresLowercase: [
            ...allCinchStoresLowercase
        ]
    };
}

// EXTERNAL MODULE: ../../../node_modules/zustand/esm/index.mjs + 1 modules
var esm = __webpack_require__(23939);
// EXTERNAL MODULE: ../../../node_modules/zustand/esm/middleware.mjs
var middleware = __webpack_require__(37540);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-drawer/use-drawer.hook.ts


const useDrawer = (0,esm/* create */.Ue)()((0,middleware/* devtools */.mW)((set)=>({
        isDrawerOpen: false,
        setIsDrawerOpen: (shouldOpen)=>set({
                isDrawerOpen: shouldOpen
            })
    })));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-drawer/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-responsive-environment/use-responsive-environment.ts

const use_responsive_environment_useResponsiveEnvironment = ()=>{
    const [isServer, setIsServer] = useState(true);
    const [device, setDevice] = useState("mobile");
    useEffect(()=>{
        // useEffect is client side only
        setIsServer(false);
        const handleResize = ()=>{
            if (window.innerWidth < 768) {
                setDevice("mobile");
            } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                setDevice("tablet");
            } else {
                setDevice("desktop");
            }
        };
        // Initial check
        handleResize();
        // Listen for resize events
        window.addEventListener("resize", handleResize);
        // Cleanup
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return {
        isMobile: device === "mobile" || isServer,
        isTablet: !isServer && device === "tablet",
        isDesktop: !isServer && device === "desktop"
    };
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-responsive-environment/index.ts


// EXTERNAL MODULE: ../../../node_modules/next/router.js
var router = __webpack_require__(35837);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/convert-filter-value-to-url-segment/convert-filter-value-to-url-segment.ts


function convert_filter_value_to_url_segment_convertFilterValueToUrlSegment(filterKey, filterValue) {
    const normalisedValue = filterValue.toLowerCase().replace(/ /g, "-");
    switch(filterKey){
        case "bodyType":
            return `${normalisedValue}-body-type`;
        case "colour":
            return `${normalisedValue}-colour`;
        case "doors":
            return `${normalisedValue}-doors`;
        case "driveType":
            return `${getKeyForValueFromMap(driveTypeValueMappings, filterValue)}-drive-type`;
        case "fuelType":
            return `${normalisedValue}-fuel-type`;
        case "gearbox":
            return `${normalisedValue}-gearbox`;
        case "seats":
            return `${normalisedValue}-seats`;
        default:
            return normalisedValue;
    }
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/convert-raw-search-filters/convert-raw-search-filters.ts

const { defaultFilters , defaultNonFilterParams , searchFilterKeys: convert_raw_search_filters_searchFilterKeys  } = search_src/* constants */._G;
function convert_raw_search_filters_convertRawSearchFiltersToSearchFilters(raw, allCinchStores) {
    const parsedEntries = Object.fromEntries(Object.entries(raw).map(([key, value])=>{
        // when store=all-stores in the URL, filter on all possible individual store names
        if (key === "store" && value === "all-stores") {
            return [
                key,
                allCinchStores
            ];
        } else if (convert_raw_search_filters_searchFilterKeys.includes(key)) {
            return [
                key,
                value.split(",")
            ];
        } else if (key === "useMonthly") {
            return [
                key,
                value === "true"
            ];
        } else {
            return [
                key,
                Number.parseInt(value)
            ];
        }
    }));
    return {
        ...defaultFilters,
        ...defaultNonFilterParams,
        ...parsedEntries
    };
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/convert-search-filters-to-query-params/convert-search-filters-to-query-params.ts

const { defaultFilters: convert_search_filters_to_query_params_defaultFilters , defaultNonFilterParams: convert_search_filters_to_query_params_defaultNonFilterParams  } = search_src/* constants */._G;
const defaultParams = {
    ...convert_search_filters_to_query_params_defaultFilters,
    ...convert_search_filters_to_query_params_defaultNonFilterParams
};
function convert_search_filters_to_query_params_convertSearchFiltersToQueryParams(filters, allCinchStores) {
    const urlParams = new URLSearchParams();
    const filterEntries = Object.entries(filters) // maintain consistent order of keys
    .sort((a, b)=>a[0].localeCompare(b[0]));
    for (const [key, value] of filterEntries){
        if (key === "store" && Array.isArray(value) && value.length === 1 && (allCinchStores === null || allCinchStores === void 0 ? void 0 : allCinchStores.length) === 1 && allCinchStores[0] === value[0]) {
            urlParams.set("store", "all-stores");
        } else if (Array.isArray(value) && value.length > 0) {
            urlParams.set(key, value.join(","));
        } else if (value !== defaultParams[key]) {
            urlParams.set(key, `${value}`);
        }
    }
    return urlParams;
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/csv/csv.ts
/**
 * Quite a lot of csv operations being used in the domain, if you find one not in this lib then
 * move it over and write / move its tests over too
 */ const parseCSV = (csvString = "", delim = ",")=>{
    return (csvString === null || csvString === void 0 ? void 0 : csvString.split(delim)) ?? [];
};
const isCSV = (csvString = "", delim = ",")=>{
    return (csvString === null || csvString === void 0 ? void 0 : csvString.includes(delim)) && typeof csvString === "string";
};
const makeCSV = (arrayString = [], delim = ",")=>{
    return (arrayString === null || arrayString === void 0 ? void 0 : arrayString.join(delim)) ?? "";
};
const mapCSV = (csvString = "", mapFn = (str)=>str, delim = ",")=>parseCSV(csvString, delim).map((element)=>mapFn(element)).join(delim);
const nthCSV = (csvString = "", nth = 0, delim = ",")=>parseCSV(csvString, delim)[nth] ?? "";
const findInCSV = (csvString = "", predicate, delim = ",")=>parseCSV(csvString, delim).find((element)=>predicate(element));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/csv/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatter-options.ts
class Options {
    _useMonthly = false;
    _mappings = {
        makes: {},
        models: {},
        variants: {}
    };
    _ageData = [];
    _facets = undefined;
    _storeData = [];
    get useMonthly() {
        return this._useMonthly;
    }
    set useMonthly(useMonthly) {
        this._useMonthly = useMonthly;
    }
    get mappings() {
        return this._mappings;
    }
    set mappings(mappings) {
        this._mappings = mappings;
    }
    get ageData() {
        return this._ageData;
    }
    set ageData(ageData) {
        this._ageData = ageData;
    }
    get facets() {
        return this._facets;
    }
    set facets(facets) {
        this._facets = facets;
    }
    get storeData() {
        return this._storeData;
    }
    set storeData(storeData) {
        this._storeData = storeData;
    }
}
const formatter_options_options = new Options();

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/extract-mappings-from-makes/extract-mappings-from-makes.ts

function extract_mappings_from_makes_extractMappingsFromMakesFacet(makes) {
    if (makes.length === 0 && Object.keys(options.mappings.makes).length > 0) {
        // This prevents a transient empty object being used by the formatters
        return options.mappings;
    }
    const output = {
        makes: {},
        models: {},
        variants: {}
    };
    makes.forEach((make)=>{
        output.makes[make.name.toUpperCase()] = make.name;
        make.models.forEach((model)=>{
            output.models[model.name.toUpperCase()] = model.name;
            model.variants.forEach((variant)=>{
                output.variants[variant.name.toUpperCase()] = variant.name;
            });
        });
    });
    return output;
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/constants/filter-constants.ts
// this was copied from libs/data/search/src/lib/constants/filters-constants.ts to get around a circular dependency issue
// despite physically being in data-search, it's exported from libs/search/feature-search-filters/src/index.ts
// TODO: fix this mess, and remove the need for duplicated constants by moving it somewhere that doesn't cause circular dependencies and allows it to be re-used!
const filter_constants_searchFilterKeys = [
    "bodyType",
    "colour",
    "seats",
    "doors",
    "fromEngineSize",
    "toEngineSize",
    "fuelType",
    "make",
    "model",
    "trim",
    "mileage",
    "fromPrice",
    "toPrice",
    "gearbox",
    "fromYear",
    "toYear",
    "driveType",
    "store",
    "tags",
    "features"
];
const nonFilterParamKeys = [
    "sortingCriteria",
    "pageSize",
    "pageNumber",
    "useMonthly"
];
const filter_constants_searchParamKeys = [
    ...filter_constants_searchFilterKeys,
    ...nonFilterParamKeys
];

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/strip-non-search-query-parameters-from-url/strip-non-search-query-parameters-from-url.ts

const strip_non_search_query_parameters_from_url_stripNonSearchQueryParametersFromUrl = (url)=>{
    const [path, originalQueryString] = url.split("?");
    const originalQueryParams = new URLSearchParams(originalQueryString);
    const newQueryParams = new URLSearchParams();
    // only copy the params we care about into the new URLSearchParams
    originalQueryParams.forEach((value, key)=>{
        if (searchParamKeys.includes(key)) {
            newQueryParams.set(key, value);
        }
    });
    // sort in place by key name to provide a stable order, and hopefully further increase cache hits
    newQueryParams.sort();
    const newQueryString = `${newQueryParams}`;
    if (newQueryString) {
        return `${path}?${newQueryParams}`;
    }
    return path;
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/get-used-cars-api-request-url-for-url-path/get-used-cars-api-request-url-for-url-path.ts


const get_used_cars_api_request_url_for_url_path_getUsedCarsApiRequestUrlForUrlPath = (urlPath)=>{
    const urlWithoutLeadingSlash = urlPath.startsWith("/") ? urlPath.slice(1) : urlPath;
    const urlWithNonSearchParamsRemoved = stripNonSearchQueryParametersFromUrl(urlWithoutLeadingSlash);
    const searchServiceUrl = readFromEnv(Env.SearchServiceUrl);
    return `${searchServiceUrl}/used-cars?url=${encodeURIComponent(urlWithNonSearchParamsRemoved)}`;
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/get-active-filters/get-active-filters.ts

const { defaultFilters: get_active_filters_defaultFilters  } = search_src/* constants */._G;
const arraysContainsEqualValues = (a, b)=>{
    if (a.length !== b.length) {
        return false;
    }
    return a.every((item)=>b.includes(item)) && b.every((item)=>a.includes(item));
};
const getActiveFilters = (filters)=>Object.entries(filters).reduce((activeFilters, [key, value])=>{
        const filtersKey = key;
        if (!arraysContainsEqualValues(get_active_filters_defaultFilters[filtersKey], value)) {
            activeFilters.push(filtersKey);
        }
        return activeFilters;
    }, []);

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/get-ordered-parsed-filter-map/get-ordered-parsed-filter-map.ts

const urlSegmentOrderPriorities = new Map([
    [
        "make",
        1
    ],
    [
        "model",
        2
    ],
    [
        "trim",
        3
    ],
    [
        "fuelType",
        4
    ],
    [
        "colour",
        5
    ],
    [
        "bodyType",
        6
    ],
    [
        "gearbox",
        7
    ],
    [
        "doors",
        8
    ],
    [
        "seats",
        9
    ],
    [
        "driveType",
        10
    ]
]);
const createReorderedParsedFilterMap = (parsedFilterObject, orderedPrioritiesOfParsedFilterNames)=>orderedPrioritiesOfParsedFilterNames.reduce((reorderedParsedFilterMap, priority)=>{
        // get filterName for priority
        const filterName = getKeyForValueFromMap(urlSegmentOrderPriorities, priority);
        if (!filterName) {
            throw new Error(`There is no filterName with priority ${priority}`);
        }
        reorderedParsedFilterMap.set(filterName, parsedFilterObject[filterName]);
        return reorderedParsedFilterMap;
    }, new Map());
const isNumericArrayInAscendingOrder = (array)=>{
    for(let i = 1; i < array.length; i++){
        if (array[i] < array[i - 1]) {
            return false;
        }
    }
    return true;
};
const getPrioritiesOfParsedFilterNames = (filterNames)=>filterNames.map((filterName)=>{
        const priority = urlSegmentOrderPriorities.get(filterName);
        if (!priority) throw new Error(`FilterName ${filterName} is unrecognised!`);
        return priority;
    });
const getOrderedPrioritiesOfParsedFilterNames = (prioritiesOfParsedFilterNames)=>[
        ...prioritiesOfParsedFilterNames
    ].sort((a, b)=>a - b);
/**
 * Checks if the URL path is in order. If it is, it returns the original input path
 * otherwise it will sort and return the sorted path.
 * It also returns if the path was sorted
 * @param parsedFilterMap The parsed URL path
 * @returns A validated, sorted URL path and a boolean to indicate if this function sorted the path
 */ function get_ordered_parsed_filter_map_getOrderedParsedFilterMap(parsedFilterMap) {
    const parsedFilterObject = Object.fromEntries(parsedFilterMap);
    const filterNames = Object.keys(parsedFilterObject);
    const prioritiesOfParsedFilterNames = getPrioritiesOfParsedFilterNames(filterNames);
    if (!isNumericArrayInAscendingOrder(prioritiesOfParsedFilterNames)) {
        const orderedPrioritiesOfParsedFilterNames = getOrderedPrioritiesOfParsedFilterNames(prioritiesOfParsedFilterNames);
        const orderedParsedFilterMap = createReorderedParsedFilterMap(parsedFilterObject, orderedPrioritiesOfParsedFilterNames);
        return {
            wasParsedFilterMapReordered: true,
            orderedParsedFilterMap
        };
    }
    return {
        wasParsedFilterMapReordered: false,
        orderedParsedFilterMap: parsedFilterMap
    };
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/is-cinch-app/is-cinch-app.ts
var ref;
const is_cinch_app_isWindowUserAgentCinchApp =  true && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/map-filters-to-url/map-filters-to-url.ts


const { DEFAULT_PAGE_SIZE , DEFAULT_SORTING_CRITERIA , nonFilterParamKeys: map_filters_to_url_nonFilterParamKeys , searchFilterKeys: map_filters_to_url_searchFilterKeys , searchParamKeys: map_filters_to_url_searchParamKeys , validUrlSegmentFilterKeys  } = search_src/* constants */._G;
function addNonFilterParamToUrlParams(key, value, urlSearchParams) {
    switch(key){
        case "pageNumber":
            if (value !== 1) {
                urlSearchParams.set("pageNumber", `${value}`);
            }
            break;
        case "pageSize":
            if (value !== DEFAULT_PAGE_SIZE) {
                urlSearchParams.set("pageSize", `${value}`);
            }
            break;
        case "sortingCriteria":
            if (value !== DEFAULT_SORTING_CRITERIA) {
                urlSearchParams.set("sortingCriteria", `${value}`);
            }
            break;
        case "useMonthly":
            if (value) {
                urlSearchParams.set("useMonthly", `${value}`);
            }
            break;
    }
}
function isNonFilterParamKey(key) {
    return map_filters_to_url_nonFilterParamKeys.includes(key);
}
function isValidSegmentFilterKey(key) {
    return validUrlSegmentFilterKeys.includes(key);
}
function isStringArray(value) {
    return Array.isArray(value);
}
function map_filters_to_url_mapFiltersToUrl(filters, allCinchStores, existingParams = new URLSearchParams(window.location.search)) {
    // remove un-set filters/params & convert to map of filter key/values & urlSearchParams
    const { urlPathMap , urlSearchParams  } = Object.entries(filters).reduce(({ urlPathMap , urlSearchParams  }, [key, value])=>{
        if (isNonFilterParamKey(key)) {
            // special handling of non-filter params, don't include them in the url when the value is the default
            addNonFilterParamToUrlParams(key, value, urlSearchParams);
            return {
                urlPathMap,
                urlSearchParams
            };
        }
        if (!isStringArray(value)) {
            console.warn(`Unexpected type value for key '${key}', expected string[] but got ${typeof value}`);
            return {
                urlPathMap,
                urlSearchParams
            };
        }
        // when all possible stores are selected, show 'all-stores' in the URL params rather than listing them all
        if (key === "store" && allCinchStores.length > 0 && value.length === allCinchStores.length && allCinchStores.every((storeValue)=>value.includes(storeValue))) {
            urlSearchParams.set(key, "all-stores");
        } else if (value.length === 1 && isValidSegmentFilterKey(key)) {
            // single value filters that are allowed in the URL segments should be added to the urlPathMap
            urlPathMap.set(key, {
                searchApiValue: convertFilterValueToUrlSegment(key, value[0]),
                urlSegmentValue: value[0]
            });
        } else if (value.length > 1 || value.length === 1 && !isValidSegmentFilterKey(key)) {
            // multi-value filters and those not allowed in URL segments are added to the search params
            urlSearchParams.set(key, value.join(","));
        }
        return {
            urlPathMap,
            urlSearchParams
        };
    }, {
        urlPathMap: new Map(),
        urlSearchParams: new URLSearchParams()
    });
    // sort segments
    const { orderedParsedFilterMap: sortedParsedPath  } = getOrderedParsedFilterMap(urlPathMap);
    // truncate segments to 3 & convert extras to query parameters
    const { truncatedOrderedParsedPath: trimmedSortedParsedPath , additionalQueryParams  } = truncateSegmentsToQueryParams({
        orderedParsedFilterMap: sortedParsedPath,
        maxAllowedSegments: 3
    });
    // append additionalQueryParams to urlSearchParams
    additionalQueryParams.forEach((_, key)=>{
        if (map_filters_to_url_searchFilterKeys.includes(key)) {
            // get the value from the original filters rather than the search params, as we don't want the
            // transformed for url segment value in search params, we want the raw one
            const searchParamValue = filters[key];
            if (searchParamValue) {
                urlSearchParams.set(key, searchParamValue.join(","));
            }
        }
    });
    // Add any existing non-filter URL search params
    existingParams.forEach((value, key)=>{
        if (!map_filters_to_url_searchParamKeys.includes(key)) {
            urlSearchParams.set(key, value);
        }
    });
    // combine trimmedSortedParsedPath into a URL
    const urlPathSegments = [
        ...trimmedSortedParsedPath.values()
    ];
    // convert slashes into dashes to prevent segment overloading
    const sanitisedUrlPathSegments = urlPathSegments.map((s)=>s.searchApiValue.replace(/\//g, "-").replace(/\[/g, "(").replace(/]/g, ")"));
    // Join the segments...
    let urlPath = sanitisedUrlPathSegments.join("/");
    // if we've got any search params, add them
    if ([
        ...urlSearchParams.values()
    ].length > 0) {
        urlPath += `?${urlSearchParams}`;
    }
    return urlPath;
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/session-storage/session-storage.ts
const SearchStorageKeys = {
    "recently-viewed-vehicles": "recently-viewed-vehicles",
    usedCarsPreviousUrl: "usedCarsPreviousUrl",
    "used-cars-url-filter-history": "used-cars-url-filter-history"
};
const setSessionStorage = (storageKey, value)=>{
    if (true) {
        window.sessionStorage.setItem(storageKey, value);
    }
};
const getSessionStorage = (storageKey)=>{
    const storageValue = window.sessionStorage.getItem(storageKey);
    return typeof storageValue === "string" ? JSON.parse(storageValue) : {};
};
const session_storage_getUsedCarsUrlFilterHistoryFromSessionStorage = ()=>getSessionStorage("used-cars-url-filter-history");
const session_storage_setUsedCarsUrlFilterHistoryInSessionStorage = (usedCarsFilterState)=>setSessionStorage("used-cars-url-filter-history", JSON.stringify(usedCarsFilterState));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/session-storage/session-storage.mock.ts
const sessionStorageMock = (()=>{
    let store = {};
    return {
        getItem (key) {
            return store[key];
        },
        setItem (key, value) {
            store[key] = value;
        },
        clear () {
            store = {};
        },
        removeItem (key) {
            delete store[key];
        }
    };
})();

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/session-storage/index.ts



;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/utils/index.ts























;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters/use-search-filters.ts




const getUrlForPageNumber = (page, filters, queryParams, allCinchStores)=>{
    const [urlPart, searchParamsPart] = mapFiltersToUrl(filters, allCinchStores, new URLSearchParams(queryParams)).split("?");
    const searchParams = new URLSearchParams(searchParamsPart);
    if (page === 1) {
        searchParams.delete("pageNumber");
    } else {
        searchParams.set("pageNumber", `${page}`);
    }
    if ([
        ...searchParams.values()
    ].length > 0) {
        return `${urlPart}?${searchParams}`;
    }
    return urlPart;
};
function use_search_filters_useSearchFilters() {
    const primaryFilters = useSearchStore(useShallow((state)=>({
            bodyType: state.bodyType,
            colour: state.colour,
            doors: state.doors,
            driveType: state.driveType,
            features: state.features,
            fromEngineSize: state.fromEngineSize,
            fromPrice: state.fromPrice,
            fromYear: state.fromYear,
            fuelType: state.fuelType,
            gearbox: state.gearbox,
            make: state.make,
            mileage: state.mileage,
            model: state.model,
            seats: state.seats,
            store: state.store,
            tags: state.tags,
            toEngineSize: state.toEngineSize,
            toPrice: state.toPrice,
            toYear: state.toYear,
            trim: state.trim
        })));
    const auxFilters = useSearchStore(useShallow((state)=>({
            pageNumber: state.pageNumber,
            pageSize: state.pageSize,
            sortingCriteria: state.sortingCriteria,
            useMonthly: state.useMonthly
        })));
    const filters = Object.assign({}, primaryFilters, auxFilters);
    const functions = useSearchStore(useShallow((state)=>({
            updateFilter: state.updateFilter,
            updateFilters: state.updateFilters,
            clearFilterValue: state.clearFilterValue,
            clearAllFilters: state.clearAllFilters,
            setPageNumber: state.setPageNumber,
            setPageSize: state.setPageSize,
            setSortingCriteria: state.setSortingCriteria,
            setUseMonthly: state.setUseMonthly
        })));
    const { allCinchStores  } = useSearchStore(useShallow((state)=>({
            allCinchStores: state.allCinchStoresLowercase
        })));
    const totalFilterCount = Object.values(primaryFilters).reduce((currentCount, filter)=>currentCount + filter.length, 0);
    const { pathSegmentFilters  } = useSearchStore(useShallow((state)=>({
            pathSegmentFilters: state.pathSegmentFilters
        })));
    const router = useRouter();
    const queryParams = router.asPath.split("?")[1] ?? "";
    return {
        ...functions,
        ...auxFilters,
        params: filters,
        filters: primaryFilters,
        totalFilterCount,
        pathSegmentFilters,
        getUrlForPageNumber: (page)=>getUrlForPageNumber(page, filters, queryParams, allCinchStores)
    };
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters/index.ts


// EXTERNAL MODULE: ../../../node_modules/fast-deep-equal/react.js
var fast_deep_equal_react = __webpack_require__(77573);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/utils.ts

const { makeCSV: utils_makeCSV , parseCSV: utils_parseCSV  } = csv_namespaceObject;
function truncateSelectedValues(matchingValuesToDisplay, length = 4, conjunction = "or") {
    if (matchingValuesToDisplay.length <= 1) {
        return utils_makeCSV(matchingValuesToDisplay);
    }
    const indexToSplitAt = Math.min(matchingValuesToDisplay.length - 1, length);
    const firstPart = matchingValuesToDisplay.slice(0, indexToSplitAt);
    const lastPart = matchingValuesToDisplay.slice(indexToSplitAt);
    const showPlusStyleEnding = matchingValuesToDisplay.length > length;
    const lastPartFormatted = showPlusStyleEnding ? ` +\u00A0${lastPart.length}\u00A0more` : ` ${conjunction} ${lastPart[0]}`;
    return utils_makeCSV(firstPart, ", ") + lastPartFormatted;
}
function stringifyReferenceDataValue(numberTypeReferenceData) {
    return numberTypeReferenceData.map((option)=>({
            value: option.value.toString(),
            label: option.label
        }));
}
function findSelectedOptionLabel(referenceData, selectedValue = "") {
    var ref;
    return ((ref = referenceData.find((data)=>data.value === selectedValue)) === null || ref === void 0 ? void 0 : ref.label) ?? selectedValue;
}
function formatSelectionsArray(selections, options) {
    return selections.map((selectedValue)=>findSelectedOptionLabel(options, selectedValue));
}
function formatSelections(selections, options) {
    return utils_parseCSV(selections).map((selectedValue)=>findSelectedOptionLabel(options, selectedValue));
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/body-type-formatter.ts


const body_type_formatter_getFormattedBodyType = (bodyTypeSelections = [])=>truncateSelectedValues(formatSelectionsArray(bodyTypeSelections, search_src/* bodyTypesData */.kg));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/colour-formatter.ts


const colour_formatter_getFormattedColour = (colourSelections = [])=>truncateSelectedValues(formatSelectionsArray(colourSelections, search_src/* coloursData */.t7));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/doors-formatter.ts


const doors_formatter_getFormattedDoors = (doorSelections = [])=>truncateSelectedValues(formatSelectionsArray(doorSelections, search_src/* doorsData */.P8));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/drive-type-formatter.ts


const drive_type_formatter_getFormattedDriveType = (driveTypeSelections = [])=>truncateSelectedValues(formatSelectionsArray(driveTypeSelections, search_src/* driveTypesData */.vL));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/engine-size-formatter.ts


function stringifyEngineSizeReferenceDataValue(engineSizesReferenceData, key) {
    return engineSizesReferenceData.map((option)=>({
            value: option[key].toString(),
            label: option.label
        }));
}
const getFormattedFromEngineSizeCc = (engineSizeCcSelection = -1)=>{
    if (engineSizeCcSelection === -1) return "";
    return `From ${findSelectedOptionLabel(stringifyEngineSizeReferenceDataValue(search_src/* engineSizeRangesData */.Wk, "min"), engineSizeCcSelection.toString())}`;
};
const getFormattedToEngineSizeCc = (engineSizeCcSelection = -1)=>{
    if (engineSizeCcSelection === -1) return "";
    return `To ${findSelectedOptionLabel(stringifyEngineSizeReferenceDataValue(search_src/* engineSizeRangesData */.Wk, "max"), engineSizeCcSelection.toString())}`;
};
const engine_size_formatter_getFormattedEngineSizeCcRange = (fromEngineSizeCcSelection = -1, toEngineSizeCcSelection = -1)=>{
    if (fromEngineSizeCcSelection === -1 && toEngineSizeCcSelection === -1) return "";
    const fromEngineSizeCc = getFormattedFromEngineSizeCc(fromEngineSizeCcSelection);
    let toEngineSizeCc = getFormattedToEngineSizeCc(toEngineSizeCcSelection);
    if (fromEngineSizeCc) {
        toEngineSizeCc = ` ${toEngineSizeCc.toLowerCase()}`;
    }
    return `${fromEngineSizeCc}${toEngineSizeCc}`.trim();
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/features-formatter.ts


const features_formatter_getFormattedFeatures = (featureSelections)=>truncateSelectedValues(formatSelectionsArray(featureSelections, search_src/* featuresData */.fn), 4, "and");

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/fuel-type-formatter.ts


const fuel_type_formatter_getFormattedFuelType = (fuelTypeSelections = [])=>truncateSelectedValues(formatSelectionsArray(fuelTypeSelections, search_src/* fuelTypesData */.GM));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/gearbox-formatter.ts


const gearbox_formatter_getFormattedGearbox = (transmissionTypeSelections = [])=>truncateSelectedValues(formatSelectionsArray(transmissionTypeSelections, search_src/* transmissionTypeData */.Xl));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/make-model-variant-formatter.ts


const { isCSV: make_model_variant_formatter_isCSV , mapCSV: make_model_variant_formatter_mapCSV , parseCSV: make_model_variant_formatter_parseCSV  } = csv_namespaceObject;
const mapFormattedMake = (make, mappings)=>{
    const output = mappings.makes[make.toUpperCase()] ?? make;
    return output;
};
const make_model_variant_formatter_getFormattedMake = (make = "", mappings)=>make_model_variant_formatter_isCSV(make) ? make_model_variant_formatter_mapCSV(make, (part)=>mapFormattedMake(part, mappings)) : mapFormattedMake(make, mappings);
const mapFormattedModel = (model, mappings)=>mappings.models[model.toUpperCase()] ?? model;
const make_model_variant_formatter_getFormattedModel = (model = "", mappings)=>make_model_variant_formatter_isCSV(model) ? make_model_variant_formatter_mapCSV(model, (part)=>mapFormattedModel(part, mappings)) : mapFormattedModel(model, mappings);
const mapFormattedVariant = (variant, mappings)=>{
    const uppercaseVariant = variant.toUpperCase();
    return mappings.variants[uppercaseVariant] ?? variant;
};
const make_model_variant_formatter_getFormattedVariant = (variant = "", mappings)=>make_model_variant_formatter_isCSV(variant) ? truncateSelectedValues(make_model_variant_formatter_parseCSV(variant).map((element)=>mapFormattedVariant(element, mappings))) : mapFormattedVariant(variant, mappings);

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/mileage-formatter.ts

const mileage_formatter_getFormattedMileage = (mileageSelection = -1, mileageData)=>{
    if (mileageSelection === -1) return "";
    return findSelectedOptionLabel(stringifyReferenceDataValue(mileageData), mileageSelection.toString());
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/seats-formatter.ts


const seats_formatter_getFormattedSeats = (seatSelections = [])=>truncateSelectedValues(formatSelectionsArray(seatSelections, search_src/* seatsData */.FN));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/store-location-formatter.ts


const store_location_formatter_getFormattedStoreLocations = (storeSelections = [])=>truncateSelectedValues(formatSelectionsArray(storeSelections, formatter_options_options.storeData));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/tags-formatter.ts


const tags_formatter_getFormattedTags = (tags = "")=>truncateSelectedValues(formatSelections(tags.toLowerCase(), search_src/* tagsData */.Ly));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/year-formatter.ts

const getFormattedFromYear = (yearSelection = -1, ageData)=>{
    if (yearSelection === -1) return "";
    return `From ${findSelectedOptionLabel(stringifyReferenceDataValue(ageData), yearSelection.toString())}`;
};
const getFormattedToYear = (yearSelection = -1, ageData)=>{
    if (yearSelection === -1) return "";
    return `To ${findSelectedOptionLabel(stringifyReferenceDataValue(ageData), yearSelection.toString())}`;
};
const year_formatter_getFormattedYearRange = (fromYearSelection = -1, toYearSelection = -1, ageData)=>{
    if (fromYearSelection === -1 && toYearSelection === -1) return "";
    const fromYear = getFormattedFromYear(fromYearSelection, ageData);
    let toYear = getFormattedToYear(toYearSelection, ageData);
    if (fromYear) {
        toYear = ` ${toYear.toLowerCase()}`;
    }
    return `${fromYear}${toYear}`.trim();
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/format-filter-pills.ts

















const format_filter_pills_formatFilterPill = (key, value)=>{
    switch(key){
        case "make":
            return getFormattedMake(value, options.mappings);
        case "model":
            return getFormattedModel(value, options.mappings);
        case "trim":
            return getFormattedVariant(value, options.mappings);
        case "fromPrice":
            return getFormattedPriceRange(Number.parseInt(value, 10), undefined, options.useMonthly);
        case "toPrice":
            return getFormattedPriceRange(undefined, Number.parseInt(value, 10), options.useMonthly);
        case "fromYear":
            return getFormattedYearRange(Number.parseInt(value, 10), undefined, options.ageData ?? []);
        case "toYear":
            return getFormattedYearRange(undefined, Number.parseInt(value, 10), options.ageData ?? []);
        case "mileage":
            return getFormattedMileage(Number.parseInt(value, 10), mileageData ?? []);
        case "fuelType":
            return getFormattedFuelType([
                value
            ]);
        case "colour":
            return getFormattedColour([
                value
            ]);
        case "bodyType":
            return getFormattedBodyType([
                value
            ]);
        case "gearbox":
            return getFormattedGearbox([
                value
            ]);
        case "fromEngineSize":
            return getFormattedEngineSizeCcRange(Number.parseInt(value, 10));
        case "toEngineSize":
            return getFormattedEngineSizeCcRange(undefined, Number.parseInt(value, 10));
        case "doors":
            return getFormattedDoors([
                value
            ]);
        case "seats":
            return getFormattedSeats([
                value
            ]);
        case "driveType":
            return getFormattedDriveType([
                value
            ]);
        case "tags":
            return getFormattedTags(value);
        case "features":
            return getFormattedFeatures([
                value
            ]);
        case "store":
            return getFormattedStoreLocations([
                value
            ]);
        default:
            return value;
    }
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/price-formatter.ts
const formatPriceToPounds = (price, useMonthly = false)=>`£${price.toLocaleString()}${useMonthly ? " p/m" : ""}`;
const getFormattedFromPrice = (priceSelection = -1, useMonthly = false)=>{
    if (priceSelection === -1) return "";
    return `From ${formatPriceToPounds(priceSelection, useMonthly)}`;
};
const getFormattedToPrice = (priceSelection = -1, useMonthly = false)=>{
    if (priceSelection === -1) return "";
    return `Up to ${formatPriceToPounds(priceSelection, useMonthly)}`;
};
const price_formatter_getFormattedPriceRange = (fromPriceSelection = -1, toPriceSelection = -1, useMonthly = false)=>{
    if (fromPriceSelection === -1 && toPriceSelection === -1) return "";
    const fromPrice = getFormattedFromPrice(fromPriceSelection, useMonthly);
    let toPrice = getFormattedToPrice(toPriceSelection, useMonthly);
    if (fromPrice) {
        toPrice = ` ${toPrice.replace("Up ", "").toLowerCase()}`;
    }
    return `${fromPrice}${toPrice}`.trim();
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/price-range-and-tags-formatter.ts

const getFormattedPriceRangeAndTags = (priceRange = "", tags = "")=>{
    if (priceRange && tags) return truncateSelectedValues([
        priceRange,
        tags
    ], 4, "and");
    return priceRange || tags;
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/filter-option-value-formatter.ts

function getFacetCount(facetData, item) {
    const facetCounts = facetData;
    let aliasCount = 0;
    if (item.facetKeys) {
        /* If the item has aliases/synonyms e.g:
      {
        label: 'Automatic',
        value: 'automatic',
        facetKeys: ['semi-auto', 'automatic'],
      }
      The the total count will be its main value (item.value) and all
      the counts of the aliases (item.faceKeys). However if the facetKey
      array contains the value, then we filter that to prevent counting
      the main value twice
    */ aliasCount = item.facetKeys.filter((aliasValue)=>aliasValue !== item.value).reduce((accumilatorCount, aliasValue)=>accumilatorCount + (facetCounts[aliasValue] ?? 0), 0);
    }
    const facetCount = facetCounts[item.value] ?? 0;
    return facetCount + aliasCount;
}
function filter_option_value_formatter_formatFilterOptionValue(key, referenceData) {
    var ref;
    const currentFacet = (ref = options.facets) === null || ref === void 0 ? void 0 : ref[key];
    if (!currentFacet) return [];
    return referenceData.map((item)=>({
            ...item,
            doc_count: getFacetCount(currentFacet, item)
        }));
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/formatters/index.ts

















// EXTERNAL MODULE: ../../../node_modules/swr/core/dist/index.mjs + 1 modules
var dist = __webpack_require__(14572);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/swr-middleware/keep-previous-data-while-loading-new-data-middleware.ts

// This is a SWR middleware for keeping the data even if key changes.
// https://swr.vercel.app/docs/middleware#keep-previous-result
const keep_previous_data_while_loading_new_data_middleware_keepPreviousDataWhileLoadingNewDataMiddleware = (useSWRNext)=>(key, fetcher, config)=>{
        // Use a ref to store previous returned data.
        const laggyDataRef = useRef();
        // Actual SWR hook.
        const swr = useSWRNext(key, fetcher, config);
        useEffect(()=>{
            // Update ref if data is not undefined.
            if (swr.data !== undefined) {
                laggyDataRef.current = swr.data;
            }
        }, [
            swr.data
        ]);
        // Expose a method to clear the laggy data, if any.
        const resetLaggy = useCallback(()=>{
            laggyDataRef.current = undefined;
        }, []);
        // Fallback to previous data if the current data is undefined.
        const dataOrLaggyData = swr.data === undefined ? laggyDataRef.current : swr.data;
        // Is it showing previous data?
        const isLagging = swr.data === undefined && laggyDataRef.current !== undefined;
        // Also add a `isLagging` field to SWR.
        return Object.assign({}, swr, {
            data: dataOrLaggyData,
            isLagging,
            resetLaggy
        });
    };

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-results/use-search-results.ts






const use_search_results_httpClient = axios_default().create();
const fetcher = async (url)=>await use_search_results_httpClient.get(url).then((res)=>res.data);
function use_search_results_useSearchResults(params) {
    const searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    const { allCinchStoresLowercase  } = useCinchStores();
    const queryParams = convertSearchFiltersToQueryParams(params, allCinchStoresLowercase);
    const url = `${searchApiUrl}/vehicles${queryParams.toString() ? `?${queryParams}` : ""}`;
    return useSWR(url, fetcher, {
        use: [
            keepPreviousDataWhileLoadingNewDataMiddleware
        ]
    });
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-results/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/use-search-filters-formatting.ts









let previousSearchResultsData;
let previousUseMonthly = false;
const getAgeDataFromVehicleYearFacets = (vehicleYearFacets)=>{
    if (!vehicleYearFacets) {
        return [];
    }
    return Object.keys(vehicleYearFacets).filter((key)=>Boolean(Number.parseInt(key))).map((key)=>({
            label: key.toString(),
            value: Number.parseInt(key)
        }));
};
const summaryFormatters = {
    getFormattedMake: (value)=>make_model_variant_formatter_getFormattedMake(value, formatter_options_options.mappings),
    getFormattedModel: (value)=>make_model_variant_formatter_getFormattedModel(value, formatter_options_options.mappings),
    getFormattedVariant: (value)=>make_model_variant_formatter_getFormattedVariant(value, formatter_options_options.mappings),
    getFormattedPriceRange: (from, to)=>price_formatter_getFormattedPriceRange(from, to, formatter_options_options.useMonthly),
    getFormattedYearRange: (from, to)=>year_formatter_getFormattedYearRange(from, to, formatter_options_options.ageData),
    getFormattedMileage: mileage_formatter_getFormattedMileage,
    getFormattedFuelType: fuel_type_formatter_getFormattedFuelType,
    getFormattedColour: colour_formatter_getFormattedColour,
    getFormattedBodyType: body_type_formatter_getFormattedBodyType,
    getFormattedGearbox: gearbox_formatter_getFormattedGearbox,
    getFormattedEngineSizeCcRange: engine_size_formatter_getFormattedEngineSizeCcRange,
    getFormattedDoors: doors_formatter_getFormattedDoors,
    getFormattedSeats: seats_formatter_getFormattedSeats,
    getFormattedDriveType: drive_type_formatter_getFormattedDriveType,
    getFormattedTags: tags_formatter_getFormattedTags,
    getFormattedFeatures: features_formatter_getFormattedFeatures,
    getFormattedPriceRangeAndTags: (from, to, tags)=>{
        return getFormattedPriceRangeAndTags(price_formatter_getFormattedPriceRange(from, to), tags_formatter_getFormattedTags(tags));
    },
    getFormattedStoreLocations: store_location_formatter_getFormattedStoreLocations
};
function use_search_filters_formatting_useSearchFiltersFormatting() {
    const { params , useMonthly  } = useSearchFilters();
    const { data: searchResultsData  } = useSearchResults(params);
    if (searchResultsData && !isEqual(searchResultsData, previousSearchResultsData)) {
        var ref, ref1, ref2;
        options.ageData = getAgeDataFromVehicleYearFacets(searchResultsData === null || searchResultsData === void 0 ? void 0 : (ref = searchResultsData.facets) === null || ref === void 0 ? void 0 : ref.vehicleYear);
        options.mappings = extractMappingsFromMakesFacet((searchResultsData === null || searchResultsData === void 0 ? void 0 : (ref1 = searchResultsData.facets) === null || ref1 === void 0 ? void 0 : ref1.makes) ?? []);
        options.storeData = getStoreDataFromAggregation((searchResultsData === null || searchResultsData === void 0 ? void 0 : (ref2 = searchResultsData.facets) === null || ref2 === void 0 ? void 0 : ref2.store) ?? {});
        options.facets = searchResultsData === null || searchResultsData === void 0 ? void 0 : searchResultsData.facets;
        previousSearchResultsData = searchResultsData;
    }
    if (!isEqual(useMonthly, previousUseMonthly)) {
        options.useMonthly = useMonthly;
        previousUseMonthly = useMonthly;
    }
    return {
        ageData: options.ageData,
        formatFilterPill,
        summaryFormatters,
        formatFilterOptionValue
    };
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-filters-formatting/index.ts




;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-alert-filters-formatting/use-search-alert-filters-formatting.ts


const MAX_FILTER_INDEX_TO_SHOW = 4;
const use_search_alert_filters_formatting_useSearchAlertFiltersFormatting = ()=>{
    const { formatFilterPill  } = useSearchFiltersFormatting();
    const { filters  } = useSearchFilters();
    const getFlattenedFilters = ()=>Object.entries(filters).flatMap(([key, values])=>{
            const filterKey = key;
            return values.map((value, index)=>({
                    key: `${key}-${index}`,
                    value,
                    display: formatFilterPill(filterKey, value)
                }));
        });
    const transformExtraFilter = (filterItem, index, filters)=>{
        if (index === MAX_FILTER_INDEX_TO_SHOW && filters.length > MAX_FILTER_INDEX_TO_SHOW + 1) {
            return {
                key: "extras",
                value: "extras",
                display: `+ ${filters.length - MAX_FILTER_INDEX_TO_SHOW} more filters`
            };
        }
        return filterItem;
    };
    return getFlattenedFilters().map((element, index, array)=>transformExtraFilter(element, index, array)).slice(0, MAX_FILTER_INDEX_TO_SHOW + 1);
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-alerts/use-search-alerts.ts





const use_search_alerts_httpClient = axios_default().create();
function use_search_alerts_useSearchAlerts() {
    const { params  } = useSearchFilters();
    const searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    const queryParams = convertSearchFiltersToQueryParams(params);
    const [fetchStatus, setFetchStatus] = useState("initial");
    const [error, setError] = useState(null);
    const url = `${searchApiUrl}/alert`;
    const registerSearchAlert = async (email, frequency)=>{
        if (!email || !frequency) {
            return;
        }
        setError(null);
        setFetchStatus("pending");
        try {
            await use_search_alerts_httpClient.post(url, {
                sa_email_address: email,
                sa_frequency: frequency,
                sa_url: `?${queryParams}`
            }, {
                headers: {
                    "x-search-api-consumer": "search-used-cars"
                }
            });
            setFetchStatus("success");
        } catch (error_) {
            setError(error_);
            setFetchStatus("error");
        }
    };
    return {
        registerSearchAlert,
        fetchStatus,
        error
    };
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-alerts/index.ts


// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-alerts-drawer/use-search-alerts-drawer.tsx




const use_search_alerts_drawer_useSearchAlertsDrawer = (searchLayoutArea)=>{
    const [showSearchAlertsDrawer, setShowSearchAlertsDrawer] = useState(false);
    const closeSearchAlertsDrawer = ()=>{
        setShowSearchAlertsDrawer(false);
    };
    const handleSearchAlertsDrawerClick = ()=>{
        setShowSearchAlertsDrawer(true);
        datadogRum.addAction(Actions.SEARCH_ALERTS_CTA_CLICKED, {
            service: Context.SEARCH_ALERTS_SERVICE,
            squad: Context.SQUAD
        });
        sendDigitalDataEvent({
            event: {
                name: "click",
                category: searchLayoutArea === "basket" ? "search-alerts-filters-basket" : "search-alerts-cta-block",
                action: "open drawer",
                label: searchLayoutArea === "noresults" ? "set up search alert - no results" : "set up search alert"
            }
        });
    };
    return {
        handleSearchAlertsDrawerClick,
        showSearchAlertsDrawer,
        closeSearchAlertsDrawer
    };
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-alerts-drawer/index.ts


// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-store/url-middleware.ts



const updateUsedCarsFilterHistoryWithPathAndFilter = (path, state)=>{
    const usedCarsFilterHistory = getUsedCarsUrlFilterHistoryFromSessionStorage();
    if (!usedCarsFilterHistory) {
        setUsedCarsUrlFilterHistoryInSessionStorage({
            [path]: state
        });
        return;
    }
    setUsedCarsUrlFilterHistoryInSessionStorage({
        ...usedCarsFilterHistory,
        [path]: state
    });
};
const url_middleware_urlMiddleware = (stateCreator, name)=>(set, get, store)=>{
        const updateUrlSet = (...newState)=>{
            set(...newState);
            // with the params we have make a url and change page url
            const state = get();
            const filtersToMap = {
                bodyType: state.bodyType,
                colour: state.colour,
                seats: state.seats,
                doors: state.doors,
                fromEngineSize: state.fromEngineSize,
                toEngineSize: state.toEngineSize,
                fuelType: state.fuelType,
                make: state.make,
                model: state.model,
                trim: state.trim,
                mileage: state.mileage,
                fromPrice: state.fromPrice,
                toPrice: state.toPrice,
                gearbox: state.gearbox,
                fromYear: state.fromYear,
                toYear: state.toYear,
                driveType: state.driveType,
                store: state.store,
                tags: state.tags,
                features: state.features,
                sortingCriteria: state.sortingCriteria,
                pageNumber: state.pageNumber,
                pageSize: state.pageSize,
                useMonthly: state.useMonthly
            };
            const path = mapFiltersToUrl(filtersToMap, state.allCinchStoresLowercase);
            updateUsedCarsFilterHistoryWithPathAndFilter(path, filtersToMap);
            Router.push(`/${path}`, undefined, {
                shallow: true
            });
            // not related to the URL, so if we add similar things here in the future, may want moving into a separate middleware
            datadogRum.setGlobalContextProperty("search-filters", filtersToMap);
        };
        store.setState = updateUrlSet;
        return stateCreator(updateUrlSet, get, store);
    };

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-store/initialise-search-store.ts





const facetDependants = new Map([
    [
        "make",
        [
            "model",
            "trim"
        ]
    ],
    [
        "model",
        [
            "trim"
        ]
    ]
]);
const convertPartialRawFiltersToPartialFilters = (pathSegmentsFromUrl)=>Object.fromEntries(Object.entries(pathSegmentsFromUrl).map(([key, value])=>[
            key,
            value.split(",")
        ]));
const initialise_search_store_initialiseSearchStore = ({ params , isInsideStoryblok , isSsrUserAgentCinchApp , allCinchStores , pathSegmentsFromUrl  })=>{
    const allCinchStoresLowercase = allCinchStores.map((value)=>value.toLowerCase());
    const initialState = convertRawSearchFiltersToSearchFilters(params, allCinchStoresLowercase);
    const pathSegmentFilters = convertPartialRawFiltersToPartialFilters(pathSegmentsFromUrl);
    if (true) {
        const initialUrl = mapFiltersToUrl(initialState, allCinchStoresLowercase);
        const usedCarsUrlFilterHistoryFromSessionStorage = getUsedCarsUrlFilterHistoryFromSessionStorage();
        setUsedCarsUrlFilterHistoryInSessionStorage({
            ...usedCarsUrlFilterHistoryFromSessionStorage,
            [initialUrl]: initialState
        });
    }
    return createStore(devtools(urlMiddleware((set, get)=>{
        return {
            ...initialState,
            isInsideStoryblok,
            isSsrUserAgentCinchApp,
            allCinchStores,
            allCinchStoresLowercase,
            pathSegmentFilters,
            updateFilter (filter, value) {
                const newState = {
                    pageNumber: 1
                };
                // this clears a facets dependants. For example if a make is changed,
                // the facets 'model' and 'trim' will be cleared also as they depend on make.
                // Dependants are maintained in the `facetDependants` map
                if (facetDependants.has(filter)) {
                    const dependants = facetDependants.get(filter);
                    dependants === null || dependants === void 0 ? void 0 : dependants.forEach((dependant)=>newState[dependant] = []);
                }
                if (filter === "make" || filter === "model") {
                    newState[filter] = value[0] === "" ? [] : value;
                } else if (filter === "store" && value[0] === "all-stores") {
                    newState.store = [
                        ...get().allCinchStores
                    ];
                } else {
                    newState[filter] = value[0] === "-1" ? [] : value;
                }
                set((state)=>({
                        ...state,
                        ...newState
                    }));
            },
            /**
         * This merges the provided partial filter state over the existing state
         *
         * Note that this does *not* apply any of the logic that `updateFilter` would,
         * so you can end up with a state that has invalid combinations of make/model/trim,
         * or invalid values like `-1` or `` instead of clearing the filter value
         */ updateFilters (filters) {
                set((state)=>({
                        ...state,
                        ...filters
                    }));
            },
            /**
         * Update the search params state using the ParsedParamsFromUrl, merged over the default params
         *
         * This will reset the existing search params state, only setting values present in parsedParamsFromUrl
         */ updateSearchParamsStateFromResponse (parsedParamsFromUrl, pathSegmentsFromUrl = {}) {
                const newSearchParamsState = convertRawSearchFiltersToSearchFilters(parsedParamsFromUrl, get().allCinchStoresLowercase);
                const newPathSegmentFiltersState = convertPartialRawFiltersToPartialFilters(pathSegmentsFromUrl);
                set((state)=>({
                        ...state,
                        ...newSearchParamsState,
                        pathSegmentFilters: newPathSegmentFiltersState
                    }));
            },
            clearFilterValue (filterType, filterValue) {
                set((state)=>{
                    const newState = {
                        pageNumber: 1,
                        [filterType]: state[filterType].filter((value)=>value !== filterValue)
                    };
                    // this clears a facets dependants. For example if a make is cleared,
                    // the facets 'model' and 'trim' will be cleared also as they depend on make.
                    // Dependants are maintained in the `facetDependants` map
                    if (facetDependants.has(filterType)) {
                        const dependants = facetDependants.get(filterType);
                        dependants === null || dependants === void 0 ? void 0 : dependants.forEach((dependant)=>newState[dependant] = []);
                    }
                    return {
                        ...state,
                        ...newState
                    };
                });
            },
            clearAllFilters () {
                set((state)=>({
                        ...state,
                        ...constants.defaultFilters,
                        pageNumber: 1
                    }));
            },
            setPageNumber (page) {
                set((state)=>({
                        ...state,
                        pageNumber: page
                    }));
            },
            setPageSize (size) {
                set((state)=>({
                        ...state,
                        pageSize: size,
                        pageNumber: 1
                    }));
            },
            setSortingCriteria (sortingCriteria) {
                set((state)=>({
                        ...state,
                        sortingCriteria,
                        pageNumber: 1
                    }));
            },
            setUseMonthly (useMonthly) {
                set((state)=>({
                        ...state,
                        useMonthly,
                        toPrice: [],
                        fromPrice: [],
                        pageNumber: 1
                    }));
            },
            isCinchStoreDrawerOpen: false,
            setIsCinchStoreDrawerOpen (open) {
                set((state)=>({
                        ...state,
                        isCinchStoreDrawerOpen: open
                    }));
            }
        };
    }), {
        enabled: "production" === "development"
    }));
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-search-store/search-store-provider.tsx




const SearchStoreProvider = ({ children , params , isInsideStoryblok , allCinchStores , pathSegmentsFromUrl  })=>{
    const storeRef = useRef();
    if (!storeRef.current) {
        storeRef.current = initialiseSearchStore({
            params,
            isInsideStoryblok,
            allCinchStores,
            pathSegmentsFromUrl
        });
    }
    return /*#__PURE__*/ _jsx(SearchStoreContext.Provider, {
        value: storeRef.current,
        children: children
    });
};

// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var storyblok_src = __webpack_require__(60782);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-storyblok-data/use-storyblok-data.ts





const use_storyblok_data_fetcher = async ({ slug , isInsideStoryblok  })=>{
    const args = {
        version: isInsideStoryblok ? "draft" : "published",
        ...isInsideStoryblok && {
            cv: Date.now()
        }
    };
    return await getStoryBySlug(slug, args, {
        strict: false
    });
};
function useStoryblokData() {
    var ref, ref1, ref2;
    const isInsideStoryblok = useSearchStore((s)=>s.isInsideStoryblok);
    const { asPath  } = useRouter();
    const slug = getStoryblokSlugFromUrl(asPath);
    const shouldFetch = slug !== "search/" && slug !== null;
    // See: https://swr.vercel.app/docs/conditional-fetching#conditional
    // and: https://swr.vercel.app/docs/arguments#multiple-arguments
    // For information on the advanced usage used here
    const { data , error , isLoading , isValidating  } = useSWR(shouldFetch ? [
        slug,
        isInsideStoryblok
    ] : null, ([slug, isInsideStoryblok])=>use_storyblok_data_fetcher({
            slug,
            isInsideStoryblok
        }));
    const story = useStoryblokState({
        story: data || undefined,
        enableBridge: isInsideStoryblok
    });
    const content = story === null || story === void 0 ? void 0 : story.content;
    return {
        headingOverride: content === null || content === void 0 ? void 0 : content.HeadingOverride,
        intro: content === null || content === void 0 ? void 0 : (ref = content.Intro) === null || ref === void 0 ? void 0 : ref[0],
        faqs: content === null || content === void 0 ? void 0 : (ref1 = content.FAQ) === null || ref1 === void 0 ? void 0 : ref1[0],
        outro: content === null || content === void 0 ? void 0 : content.Outro,
        seo: content === null || content === void 0 ? void 0 : (ref2 = content.SEO) === null || ref2 === void 0 ? void 0 : ref2[0],
        isLoading,
        isValidating,
        error
    };
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-storyblok-data/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-vehicle-count/use-vehicle-count.hook.ts



const use_vehicle_count_hook_fetcher = (url)=>axios_default().get(url).then((res)=>res.data);
const useVehicleCount = ()=>{
    const URL = `${search_src/* constants.VEHICLE_SEARCH_URL */._G.VEHICLE_SEARCH_URL}`;
    const { data  } = (0,dist/* default */.ZP)(URL, use_vehicle_count_hook_fetcher);
    const vehicleCount = data === null || data === void 0 ? void 0 : data.searchResultsCount;
    return {
        vehicleCount
    };
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-vehicle-count/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/use-used-cars-data/use-used-cars-data.ts








const use_used_cars_data_httpClient = axios_default().create();
const use_used_cars_data_fetcher = async (url)=>await use_used_cars_data_httpClient.get(url, {
        headers: {
            "x-search-api-consumer": "used-cars-page-hook"
        }
    }).then((res)=>res.data);
const use_used_cars_data_getUrlForPageNumber = (page, asPath)=>{
    const [urlPart, searchParamsPart] = asPath.split("?");
    const searchParams = new URLSearchParams(searchParamsPart);
    if (page === 1) {
        searchParams.delete("pageNumber");
    } else {
        searchParams.set("pageNumber", `${page}`);
    }
    if ([
        ...searchParams.values()
    ].length > 0) {
        return `${urlPart}?${searchParams}`;
    }
    return urlPart;
};
function use_used_cars_data_useUsedCarsData() {
    // NOTE: according the next.js useRouter docs, we shouldn't use `asPath` without checking `isReady`, and that can only be checked in a `useEffect`
    // Not doing so can cause issues when using SSR, with mismatches in the value between SSR and CSR
    // https://nextjs.org/docs/13/pages/api-reference/functions/use-router#router-object
    // But... looking at how it's used elsewhere in cinch-nx, no one is actually doing that (including us in the old useSearchFilters hook),
    // and no one has reported any issues, so we're going to use it as-is, without the `isReady` check.
    const { asPath  } = useRouter();
    const requestUrl = getUsedCarsApiRequestUrlForUrlPath(asPath);
    const searchParamMutators = useSearchStore(useShallow((state)=>({
            updateFilter: state.updateFilter,
            updateFilters: state.updateFilters,
            clearFilterValue: state.clearFilterValue,
            clearAllFilters: state.clearAllFilters,
            setPageNumber: state.setPageNumber,
            setSortingCriteria: state.setSortingCriteria,
            setUseMonthly: state.setUseMonthly
        })));
    const searchParams = useSearchStore(useShallow((state)=>({
            bodyType: state.bodyType,
            colour: state.colour,
            seats: state.seats,
            doors: state.doors,
            fromEngineSize: state.fromEngineSize,
            toEngineSize: state.toEngineSize,
            fuelType: state.fuelType,
            make: state.make,
            model: state.model,
            trim: state.trim,
            mileage: state.mileage,
            fromPrice: state.fromPrice,
            toPrice: state.toPrice,
            gearbox: state.gearbox,
            fromYear: state.fromYear,
            toYear: state.toYear,
            driveType: state.driveType,
            store: state.store,
            tags: state.tags,
            features: state.features,
            sortingCriteria: state.sortingCriteria,
            pageNumber: state.pageNumber,
            pageSize: state.pageSize,
            useMonthly: state.useMonthly
        })));
    const updateSearchParamsStateFromResponse = useSearchStore((state)=>state.updateSearchParamsStateFromResponse);
    const { isValidating , isLoading , data , error: usedCarsApiError  } = useSWR(requestUrl, use_used_cars_data_fetcher, {
        keepPreviousData: true
    });
    // when we get data back from the server, update the store to keep it in sync
    useEffect(()=>{
        if (data) {
            updateSearchParamsStateFromResponse(data.parsedParamsFromUrl);
        }
    }, [
        data,
        updateSearchParamsStateFromResponse
    ]);
    // what should we do when we've not got data yet? (eventually we usually will always have it due to SWR fallback from SSR, I think)
    if (data) {
        // extract search results parts of response
        const searchResults = {
            pageNumber: data.pageNumber,
            pageSize: data.pageSize,
            searchResultsCount: data.searchResultsCount,
            vehicleListings: data.vehicleListings,
            facets: data.facets
        };
        const urlData = {
            hasMatchingVehicleRecentlyBeenInStock: data.hasMatchingVehicleRecentlyBeenInStock,
            pathSegmentsFromUrl: data.pathSegmentsFromUrl
        };
        const totalFilterCount = Object.entries(searchParams).reduce((currentCount, [paramKey, paramValue])=>{
            // only increment the count if it's a filter param, things like pageSize/useMonthly/sortingCriteria should not be included in this count
            if (!searchFilterKeys.includes(paramKey)) {
                return currentCount;
            }
            if (Array.isArray(paramValue)) {
                return currentCount + paramValue.length;
            }
            return currentCount + 1;
        }, 0);
        const pathSegmentFilters = Object.fromEntries(Object.entries(data.pathSegmentsFromUrl ?? {}).map(([key, value])=>[
                key,
                value.split(",")
            ]));
        return {
            // search results/API request props:
            isValidating,
            isLoading,
            usedCarsApiError,
            searchResults,
            urlData,
            // search filters/params props:
            searchParams,
            totalFilterCount,
            pathSegmentFilters,
            // search filters/params setters:
            ...searchParamMutators,
            // pagination:
            getUrlForPageNumber: (pageNumber)=>use_used_cars_data_getUrlForPageNumber(pageNumber, asPath)
        };
    }
    return {
        // search results/API request props:
        isValidating,
        isLoading,
        usedCarsApiError,
        searchResults: undefined,
        urlData: undefined,
        // search filters/params props:
        searchParams,
        totalFilterCount: undefined,
        pathSegmentFilters: undefined,
        // search filters/params setters:
        ...searchParamMutators,
        // pagination:
        getUrlForPageNumber: (pageNumber)=>use_used_cars_data_getUrlForPageNumber(pageNumber, asPath)
    };
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/hooks/index.ts


















// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/find-vehicle-results-count/find-vehicle-results-count.component.tsx






const find_vehicle_results_count_component_FindVehicleResultsCount = ({ searchResultsCount , pageItemsRange , fetchStatus  }, ref)=>{
    const isLoading = fetchStatus;
    const { start , end  } = pageItemsRange;
    const startCount = start.toLocaleString();
    const endCount = end.toLocaleString();
    const resultsCount = searchResultsCount.toLocaleString();
    const setResultsText = ()=>{
        if (searchResultsCount === 0) {
            return null;
        }
        if (searchResultsCount === 1) {
            return "1 result";
        }
        return `${startCount} to ${endCount} of ${resultsCount} results`;
    };
    return /*#__PURE__*/ _jsx(Text, {
        element: "span",
        fontSizeFixed: "m",
        className: cx(styles["findVehicleResults"], {
            [skeletonStyles["inline"]]: isLoading,
            [skeletonStyles["skeleton"]]: isLoading
        }),
        id: "results-count",
        "aria-live": "polite",
        "data-testid": "results-count",
        children: /*#__PURE__*/ _jsx("span", {
            ref: ref,
            children: setResultsText()
        })
    });
};
/* harmony default export */ var find_vehicle_results_count_component = (/*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(find_vehicle_results_count_component_FindVehicleResultsCount))));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/find-vehicle-results-count/find-vehicle-results-count.container.tsx




const FindVehicleResultsCountContainer = (_, ref)=>{
    const { params  } = useSearchFilters();
    const { isLoading , data: searchResults  } = useSearchResults(params);
    const [{ pageItemsRange  }] = usePagination((searchResults === null || searchResults === void 0 ? void 0 : searchResults.pageNumber) || 0, (searchResults === null || searchResults === void 0 ? void 0 : searchResults.pageSize) || 0, (searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchResultsCount) || 0);
    return /*#__PURE__*/ _jsx(FindVehicleResultsCount, {
        searchResultsCount: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchResultsCount) || 0,
        pageItemsRange: pageItemsRange,
        fetchStatus: isLoading,
        ref: ref
    });
};
const FindVehicleResultsCountWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(FindVehicleResultsCountContainer)));
/* harmony default export */ var find_vehicle_results_count_container = ((/* unused pure expression or super */ null && (FindVehicleResultsCountWrapper)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/find-vehicle-results-count/index.ts


// EXTERNAL MODULE: ../../../node_modules/storyblok-rich-text-react-renderer/dist/index.es.js
var index_es = __webpack_require__(9372);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/rich-text-renderer/rich-text-renderer.tsx





const resolveYoutubeVideo = (props)=>isYoutubeBlok(props) ? /*#__PURE__*/ _jsx(Youtube, {
        ...props,
        className: styles["video"],
        customThumbnail: props.thumbnail.filename
    }) : null;
const renderWithResolver = (body, makeId)=>{
    return render(body, {
        nodeResolvers: {
            [NODE_IMAGE]: (_, props)=>/*#__PURE__*/ _jsx("img", {
                    ...props,
                    style: {
                        height: "auto"
                    },
                    alt: props.alt
                }),
            [NODE_PARAGRAPH]: (children)=>children ? /*#__PURE__*/ _jsx(Text, {
                    className: styles["rtParagraph"],
                    children: children
                }) : null
        },
        blokResolvers: {
            [BLOK_YOUTUBE]: (props)=>resolveYoutubeVideo(props)
        },
        ...makeId && {
            markResolvers: {
                [MARK_BOLD]: (children)=>{
                    /*#__PURE__*/ return _jsx("strong", {
                        id: children === null || children === void 0 ? void 0 : children.toLocaleString().replace(/\s/g, ""),
                        children: children
                    });
                }
            }
        }
    });
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/rich-text-renderer/index.ts


;// CONCATENATED MODULE: ../../../libs/customer-data/segment/src/lib/helpers/email-session-storage.ts
/* provided dependency */ var Buffer = __webpack_require__(75291)["Buffer"];

const windowIsAvailable = (/* unused pure expression or super */ null && ("object" !== "undefined"));
const email_session_storage_writeEmailToSessionStorage = (email)=>{
    if (!windowIsAvailable) return null;
    try {
        const emailEncoded = Buffer.from(email).toString("base64");
        window.sessionStorage.setItem("crm_enrichment:email", emailEncoded);
        return;
    } catch (error) {
        handlerError(error, "Write");
        return;
    }
};
const readEmailFromSessionStorage = ()=>{
    if (!windowIsAvailable) return null;
    try {
        const emailEncoded = window.sessionStorage.getItem("crm_enrichment:email");
        return emailEncoded ? Buffer.from(emailEncoded, "base64").toString() : null;
    } catch (error) {
        handlerError(error, "Read");
        return null;
    }
};
const handlerError = (error, type)=>{
    if (error instanceof Error) {
        datadogRum.addError(error, {
            service: `Customer Data - Segment Enrichment - ${type} Email Session Storage`,
            squad: "customer-data"
        });
    } else {
        datadogRum.addError(new Error(`Unknown error - ${type} Email Session Storage`), {
            service: `Customer Data - Segment Enrichment - ${type} Email Session Storage`,
            squad: "customer-data"
        });
    }
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/search-alerts/form/form.tsx









const form_SearchAlertsForm = ({ fetchStatus , sendDataToCustomerIo , onFrequencyChanged  })=>{
    const requestIsPending = fetchStatus === "pending";
    const hasServiceError = fetchStatus === "error";
    const emailInputRef = useRef(null);
    const radioInputRef = useRef(null);
    const [showEmailValidationMessage, setShowEmailValidationMessage] = useState(false);
    const [showFrequencyValidationMessage, setShowFrequencyValidationMessage] = useState(false);
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const sendTrackingEvents = (frequency)=>{
        datadogRum.addAction(Actions.SEARCH_ALERTS_FORM_SUBMIT, {
            squad: "search",
            service: "search-alerts"
        });
        // eslint-disable-next-line unicorn/consistent-function-scoping
        const getAnonymousId = ()=>{
            return (window === null || window === void 0 ? void 0 : window.analytics) && typeof window.analytics.user === "function" ? window.analytics.user().anonymousId() : "";
        };
        sendDigitalDataEvent({
            event: {
                name: "click",
                category: "search-alerts-form",
                action: "form submitted",
                label: "set up search alert",
                value: frequency,
                segmentID: getAnonymousId()
            }
        });
    };
    const handleAlertFormSubmit = (e)=>{
        var ref, ref1, ref2;
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const email = (ref = formData.get("email")) === null || ref === void 0 ? void 0 : ref.toString();
        const frequency = (ref1 = formData.get("search-alerts-frequency")) === null || ref1 === void 0 ? void 0 : ref1.toString();
        const isValidEmail = Boolean(email === null || email === void 0 ? void 0 : email.length) && ((ref2 = emailInputRef.current) === null || ref2 === void 0 ? void 0 : ref2.checkValidity());
        const isValidFrequency = frequency !== undefined;
        setShowEmailValidationMessage(!isValidEmail);
        setShowFrequencyValidationMessage(!isValidFrequency);
        if (!isValidFrequency && radioInputRef.current) {
            return radioInputRef.current.focus();
        }
        if (!isValidEmail && emailInputRef.current) {
            return emailInputRef.current.focus();
        }
        if (isValidFrequency) {
            sendTrackingEvents(frequency);
        }
        if (!email || !frequency) return;
        writeEmailToSessionStorage(email);
        onFrequencyChanged(frequency);
        return sendDataToCustomerIo(email, frequency);
    };
    useEffect(()=>{
        if (hasServiceError) {
            datadogRum.addError(new Error(Errors.SEARCH_ALERTS_FETCH_ERROR_API_ERROR), {
                service: Context.SEARCH_ALERTS_SERVICE,
                squad: Context.SQUAD
            });
        }
    }, [
        hasServiceError
    ]);
    return /*#__PURE__*/ _jsxs("form", {
        className: styles.form,
        onSubmit: handleAlertFormSubmit,
        noValidate: true,
        children: [
            /*#__PURE__*/ _jsxs("fieldset", {
                className: styles.formFieldset,
                "aria-describedby": showFrequencyValidationMessage ? "frequency-validation-message" : undefined,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        element: "legend",
                        fontSizeFixed: "m",
                        fontWeight: "bold",
                        className: styles.formLegend,
                        children: "How often would you like alerts?"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.formField,
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                className: styles.formRadio,
                                id: "search-alerts-daily",
                                type: "radio",
                                name: "search-alerts-frequency",
                                value: "1d",
                                "data-cy": "search-alerts-frequency-daily",
                                ref: radioInputRef
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                element: "label",
                                fontSizeFixed: "m",
                                htmlFor: "search-alerts-daily",
                                children: "Daily"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.formField,
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                className: styles.formRadio,
                                id: "search-alerts-weekly",
                                type: "radio",
                                name: "search-alerts-frequency",
                                "data-cy": "search-alerts-frequency-weekly",
                                value: "7d"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                element: "label",
                                fontSizeFixed: "m",
                                htmlFor: "search-alerts-weekly",
                                children: "Weekly"
                            })
                        ]
                    })
                ]
            }),
            showFrequencyValidationMessage && /*#__PURE__*/ _jsxs("span", {
                id: "frequency-validation-message",
                className: styles.formValidationMessage,
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "alert"
                    }),
                    "Select how often you would like alerts to continue"
                ]
            }),
            /*#__PURE__*/ _jsx(TextField, {
                id: "search-alerts-email",
                ref: emailInputRef,
                label: "Your email address",
                type: "email",
                name: "email",
                inputMode: "email",
                autoComplete: "email",
                spellCheck: "false",
                pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$",
                "data-cy": "search-alerts-email",
                classNames: {
                    container: styles.formInputContainer,
                    label: {
                        label: styles.formLabel
                    },
                    input: cx(styles.formInput, {
                        [styles.formInputError]: showEmailValidationMessage
                    })
                },
                error: {
                    show: false,
                    collapse: true
                },
                "aria-describedby": showEmailValidationMessage ? "email-validation-message" : undefined
            }),
            showEmailValidationMessage && /*#__PURE__*/ _jsxs("span", {
                id: "email-validation-message",
                className: styles.formValidationMessage,
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "alert"
                    }),
                    "Enter a valid email address to continue"
                ]
            }),
            /*#__PURE__*/ _jsx(Text, {
                fontSizeFixed: "xs",
                className: styles.formBodyCopy,
                children: "We'll only use your email to send you search alerts, unless you're already subscribed to our marketing emails. You can turn off search alerts from any alert email."
            }),
            /*#__PURE__*/ _jsxs(Text, {
                fontSizeFixed: "xs",
                className: styles.formBodyCopy,
                children: [
                    "Your data will be processed in accordance with our",
                    " ",
                    /*#__PURE__*/ _jsx(TextLink, {
                        textProps: {
                            fontSizeFixed: "xs"
                        },
                        target: "_blank",
                        href: "/privacy",
                        children: "Privacy Policy"
                    }),
                    "."
                ]
            }),
            hasServiceError && /*#__PURE__*/ _jsxs(Alert, {
                id: "search-alerts-submission-error",
                className: styles.formErrornMessage,
                type: "error",
                title: "Cannot set search alerts right now.",
                displayPanelVariant: true,
                children: [
                    "Come back and try again later. Until then, you can",
                    " ",
                    /*#__PURE__*/ _jsx(TextLink, {
                        textProps: {
                            fontSizeFixed: "s"
                        },
                        href: "/used-cars",
                        className: styles.heroLink,
                        children: "browse our cars."
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Primary, {
                type: "submit",
                isLoading: requestIsPending,
                isFullWidth: true,
                "data-cy": "search-alerts-submit",
                "aria-live": "assertive",
                "aria-describedby": hasServiceError ? "search-alerts-submission-error" : undefined,
                classNames: {
                    button: cx(styles.formSubmit, {
                        [styles.formSubmitPending]: requestIsPending
                    })
                },
                children: [
                    /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "mail",
                        size: 16
                    }),
                    requestIsPending ? "Setting search alerts" : "Set search alerts"
                ]
            })
        ]
    });
};
/* harmony default export */ var form_form = ((/* unused pure expression or super */ null && (form_SearchAlertsForm)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/search-alerts/form/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/search-alerts/drawer/drawer.tsx






const drawer_SearchAlertsDrawer = ({ onClose  })=>{
    const [emailFrequency, setEmailFrequency] = useState();
    const { registerSearchAlert , fetchStatus  } = useSearchAlerts();
    const formattedSearchAlertFilters = useSearchAlertFiltersFormatting();
    const isFetchSuccess = fetchStatus === "success";
    const emailFrequencyText = emailFrequency === "1d" ? "every day" : "each week";
    const renderInitialDrawerContent = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    fontSizeFixed: "m",
                    className: styles.drawerBodyCopy,
                    children: "Be the first to know when cars that match what you're looking for become available."
                }),
                /*#__PURE__*/ _jsx(Text, {
                    element: "h2",
                    fontSizeFixed: "m",
                    fontWeight: "bold",
                    className: styles.drawerHeading,
                    children: "Your search alerts"
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSizeFixed: "m",
                    className: styles.drawerBodyCopy,
                    children: "We'll send you email alerts for:"
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: styles.drawerList,
                    children: formattedSearchAlertFilters.map((item)=>/*#__PURE__*/ _jsx(Text, {
                            "aria-label": item.display,
                            className: styles.drawerListItem,
                            element: "li",
                            fontSizeFixed: "s",
                            children: item.display
                        }, item.key))
                }),
                /*#__PURE__*/ _jsx(Text, {
                    children: "These alerts will replace any you have set up previously."
                }),
                /*#__PURE__*/ _jsx(SearchAlertsForm, {
                    fetchStatus: fetchStatus,
                    sendDataToCustomerIo: registerSearchAlert,
                    onFrequencyChanged: setEmailFrequency
                })
            ]
        });
    const renderSuccessDrawerContent = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Text, {
                    fontSizeFixed: "m",
                    className: styles.successText,
                    "aria-live": "assertive",
                    children: [
                        "Nice one! We'll email you a fresh list of cars ",
                        emailFrequencyText,
                        " ",
                        "if we find ones you're looking for — so you won't miss out."
                    ]
                }),
                /*#__PURE__*/ _jsx(Primary, {
                    isFullWidth: true,
                    onClick: onClose,
                    children: "Continue browsing cars"
                })
            ]
        });
    const drawerHeader = isFetchSuccess ? "Search alerts set up" : "Set up search alerts";
    return /*#__PURE__*/ _jsxs(Drawer, {
        header: drawerHeader,
        onClose: onClose,
        children: [
            !isFetchSuccess && renderInitialDrawerContent(),
            isFetchSuccess && renderSuccessDrawerContent()
        ]
    });
};
/* harmony default export */ var drawer = ((/* unused pure expression or super */ null && (drawer_SearchAlertsDrawer)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/search-alerts/drawer/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/search-alerts/search-alerts-button/search-alerts-button.tsx





const SearchAlertsButton = ({ searchLayoutArea ="basket"  })=>{
    const { handleSearchAlertsDrawerClick , showSearchAlertsDrawer , closeSearchAlertsDrawer  } = useSearchAlertsDrawer(searchLayoutArea);
    const buttonStyles = {
        basket: styles.filterBasketSearchAlertButton,
        header: styles.filterHeaderSearchAlertButton,
        listings: styles.filterListingSearchAlertButton,
        noresults: styles.filterListingSearchAlertButton
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Secondary, {
                type: "button",
                classNames: {
                    button: buttonStyles[searchLayoutArea]
                },
                onClick: handleSearchAlertsDrawerClick,
                "data-cy": "search-alerts-cta",
                children: [
                    /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "mail",
                        size: 16,
                        id: "search-alert-icon",
                        className: styles.filterSearchAlertButtonIcon
                    }),
                    "Set up search alert"
                ]
            }),
            showSearchAlertsDrawer && /*#__PURE__*/ _jsx(SearchAlertsDrawer, {
                onClose: closeSearchAlertsDrawer
            })
        ]
    });
};
/* harmony default export */ var search_alerts_button = ((/* unused pure expression or super */ null && (SearchAlertsButton)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/search-alerts/search-alerts-button/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/search-alerts/index.ts




// EXTERNAL MODULE: ../../../libs/shared/experiments/adobe/src/index.ts + 14 modules
var adobe_src = __webpack_require__(82040);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/cinchapp-config/dist/index.js
var cinchapp_config_dist = __webpack_require__(82786);
// EXTERNAL MODULE: ../../../libs/shared/auth-modal/src/index.ts + 14 modules
var auth_modal_src = __webpack_require__(10025);
// EXTERNAL MODULE: ../../../libs/data/favourites/src/index.ts + 2 modules
var favourites_src = __webpack_require__(80525);
// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(82070);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/specs-list/specs-list.tsx





const specs_list_SpecsList = ({ items =[] , isPending =false , listStyleClassName , listItemClassName , isUpperCaseText =true  })=>/*#__PURE__*/ _jsx("ul", {
        className: cx(styles["list"], listStyleClassName || "", {
            [styles["upperCase"]]: isUpperCaseText
        }),
        children: items.map(({ label , value  })=>/*#__PURE__*/ _jsxs(Text, {
                element: "li",
                fontSizeFixed: "3xs",
                className: cx(styles["item"], listItemClassName || "", {
                    [skeletonStyles["base"]]: isPending,
                    [skeletonStyles["active"]]: isPending
                }),
                children: [
                    /*#__PURE__*/ _jsxs(ScreenReaderText, {
                        children: [
                            label,
                            ", "
                        ]
                    }),
                    value
                ]
            }, label))
    });
/* harmony default export */ var specs_list = ((/* unused pure expression or super */ null && (specs_list_SpecsList)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/context/finance-drawer-context.tsx


function finance_drawer_context_useFinanceDrawerContext() {
    const context = React.useContext(FinanceDrawerContext);
    return context;
}
const FinanceDrawerContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/admin-fee-button/admin-fee-button.tsx






const admin_fee_button_AdminFeeButton = ({ onAdminFeeClick , isPending  })=>{
    const adminFeeValueInPence = readFromEnv(Env.AdminFeeValue);
    const formatAdminFeeValue = ()=>{
        const adminFeeValue = Number.parseInt(adminFeeValueInPence) / 100;
        if (!Number.isNaN(adminFeeValue)) {
            return `£${adminFeeValue}`;
        }
        return "";
    };
    const handleClick = (e)=>{
        e.stopPropagation();
        if (onAdminFeeClick) onAdminFeeClick();
    };
    const ariaLabel = `Includes ${formatAdminFeeValue()} admin fee. Find out more info`;
    return /*#__PURE__*/ _jsxs(Text, {
        fontSizeFixed: "xs",
        element: "button",
        disabled: isPending,
        onClick: handleClick,
        "aria-label": ariaLabel,
        className: cx(styles["adminFeeInfoButton"], {
            [skeletonStyles["base"]]: isPending,
            [skeletonStyles["active"]]: isPending
        }),
        "data-testid": "admin-fee",
        children: [
            "Includes ",
            formatAdminFeeValue(),
            " admin fee"
        ]
    });
};
/* harmony default export */ var admin_fee_button = ((/* unused pure expression or super */ null && (admin_fee_button_AdminFeeButton)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/price/price.tsx








const numberWithCommas = (x)=>{
    if (typeof x === "string") {
        return Number.parseInt(x.replace(/,/g, ""), 10).toLocaleString();
    }
    return Math.round(x).toLocaleString();
};
const penceToPounds = (n)=>Math.round(n / 100);
const hasAValidQuote = (n)=>typeof n === "number" && n > 0;
const price_Price = ({ price , vehicleId , shouldShowCarsOnOfferTag =false , shouldShowDepositContribution =false , discountInPence , quoteRegularPaymentInPence , quoteType , isPending , onAdminFeesClick  })=>{
    const fullPrice = `£${numberWithCommas(price)}`;
    const pricePerMonth = `£${numberWithCommas(penceToPounds(quoteRegularPaymentInPence ?? 0))}`;
    const wasPriceId = `${vehicleId}-was-price`;
    const financeDrawerContext = useFinanceDrawerContext();
    const getWasPrice = ()=>{
        const discount = penceToPounds(discountInPence ?? 0);
        const wasPrice = `£${numberWithCommas(price + discount)}`;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "Was ",
                /*#__PURE__*/ _jsx("s", {
                    children: wasPrice
                })
            ]
        });
    };
    const renderPromotionalText = ()=>{
        let text;
        if (shouldShowDepositContribution) {
            text = /*#__PURE__*/ _jsx(_Fragment, {
                children: "Price includes deposit offer"
            });
        } else if (shouldShowCarsOnOfferTag) {
            text = getWasPrice();
        } else {
            return null;
        }
        return /*#__PURE__*/ _jsx(Text, {
            element: "span",
            id: wasPriceId,
            fontSizeFixed: "xs",
            fontWeight: "medium",
            "aria-hidden": true,
            className: cx(styles["promotionText"], {
                [skeletonStyles["base"]]: isPending,
                [skeletonStyles["active"]]: isPending,
                [styles["rightAligned"]]: shouldShowDepositContribution
            }),
            children: text
        });
    };
    const renderCashPrice = ()=>/*#__PURE__*/ _jsxs(Text, {
            element: "span",
            fontSizeFixed: "l",
            fontWeight: "semibold",
            "aria-describedby": discountInPence ? wasPriceId : undefined,
            className: cx(styles["cashPrice"], {
                [skeletonStyles["base"]]: isPending,
                [skeletonStyles["active"]]: isPending
            }),
            children: [
                /*#__PURE__*/ _jsx(ScreenReaderText, {
                    element: "span",
                    role: "presentation",
                    children: "Full price."
                }),
                `${fullPrice}`
            ]
        });
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["marginTop"],
        children: [
            renderPromotionalText(),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["priceContainer"],
                        children: [
                            renderCashPrice(),
                            hasAValidQuote(quoteRegularPaymentInPence) && /*#__PURE__*/ _jsxs(Text, {
                                element: "span",
                                fontSizeFixed: "l",
                                fontWeight: "semibold",
                                className: cx(styles["pricePerMonth"], {
                                    [skeletonStyles["base"]]: isPending,
                                    [skeletonStyles["active"]]: isPending
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(ScreenReaderText, {
                                        element: "span",
                                        role: "presentation",
                                        children: `Price per month. ${quoteType}. `
                                    }),
                                    pricePerMonth
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["priceInfoContainer"],
                        children: [
                            /*#__PURE__*/ _jsx(AdminFeeButton, {
                                isPending: isPending,
                                onAdminFeeClick: onAdminFeesClick
                            }),
                            hasAValidQuote(quoteRegularPaymentInPence) && (financeDrawerContext && quoteType ? /*#__PURE__*/ _jsx(Text, {
                                element: "button",
                                className: styles["quoteTypeButton"],
                                onClick: ()=>{
                                    sendDigitalDataEvent({
                                        event: {
                                            name: "click",
                                            category: "HP & PCP information",
                                            label: "info",
                                            action: "view",
                                            value: quoteType
                                        }
                                    });
                                    financeDrawerContext.setIsShowingFinanceDrawer(true);
                                },
                                fontSizeFixed: "xs",
                                "aria-label": `Find more information on ${quoteType}`,
                                children: ` /month ${quoteType.toUpperCase()}`
                            }) : /*#__PURE__*/ _jsx(Text, {
                                element: "small",
                                fontSizeFixed: "xs",
                                "aria-hidden": true,
                                children: ` /month ${quoteType === null || quoteType === void 0 ? void 0 : quoteType.toUpperCase()}`
                            }))
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var price = ((/* unused pure expression or super */ null && (price_Price)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/subtitle/subtitle.tsx






const subtitle_Subtitle = ({ children , isPending =false , className ="" , fontSize  })=>{
    const isChildrenAString = typeof children === "string";
    const content = isChildrenAString ? /*#__PURE__*/ _jsx("span", {
        dangerouslySetInnerHTML: {
            __html: children
        }
    }) : children;
    return /*#__PURE__*/ _jsx(Text, {
        fontSizeFixed: fontSize || "xs",
        className: cx(className, styles["subtitle"], {
            [skeletonStyles["base"]]: isPending,
            [skeletonStyles["active"]]: isPending
        }),
        children: isPending ? LOADING_TEXT : content
    });
};
/* harmony default export */ var subtitle = ((/* unused pure expression or super */ null && (subtitle_Subtitle)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/title/title.tsx





const title_Title = ({ children , isPending =false , type , className ="" , element ="h5" , ...props })=>/*#__PURE__*/ _jsx(Text, {
        element: element,
        className: cx(skeletonStyles["base"], {
            [skeletonStyles["active"]]: isPending
        }, className),
        type: type || TextStyles.mainTitle,
        ...props,
        children: isPending ? LOADING_TEXT : children
    });
/* harmony default export */ var title = ((/* unused pure expression or super */ null && (title_Title)));

// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 54 modules
var ui_src = __webpack_require__(83624);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/product-image/product-image.tsx





const product_image_ProductImage = ({ isAvailable , image , alt , children  })=>{
    const hasImage = image && image.length > 0;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["imgContainer"],
        children: [
            hasImage ? /*#__PURE__*/ _jsx(Image, {
                className: cx(styles["img"], {
                    [styles["unavailable"]]: !isAvailable
                }),
                src: image,
                alt: alt,
                width: 391,
                height: 220
            }) : /*#__PURE__*/ _jsx(HoldingImage, {
                text: "Image Unavailable",
                isAvailable: isAvailable
            }),
            children
        ]
    });
};
/* harmony default export */ var product_image = ((/* unused pure expression or super */ null && (product_image_ProductImage)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/card/card.tsx



const card_Card = ({ isHoverable , hasBorder , isSearchPage , element ="div" , children  })=>{
    const HtmlElement = element;
    return /*#__PURE__*/ _jsx(HtmlElement, {
        className: cx(styles["card"], {
            [styles["hoverable"]]: isHoverable && !isSearchPage,
            [styles["bordered"]]: hasBorder && !isSearchPage,
            [styles["cardSearch"]]: isSearchPage
        }),
        children: children
    });
};
/* harmony default export */ var card = ((/* unused pure expression or super */ null && (card_Card)));

// EXTERNAL MODULE: ../../../libs/design-system/components/icons/src/index.ts + 264 modules
var icons_src = __webpack_require__(58544);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/favourite-cta/favourite-cta.tsx




const favourite_cta_FavouriteCTA = ({ isPending , isSaved , onClick  })=>{
    const FAVOURITE_CAR = "Add car to favourites";
    const UNFAVOURITE_CAR = "Remove car from favourites";
    const FavouriteIcon = isSaved ? HeartFilledIcon : HeartOutlineIcon;
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        "aria-label": isSaved ? UNFAVOURITE_CAR : FAVOURITE_CAR,
        onClick: onClick,
        className: cx(styles["favouriteCta"], {
            [styles["favouriteCtaPending"]]: isPending,
            [styles["favouriteCtaSaved"]]: isSaved
        }),
        children: [
            /*#__PURE__*/ _jsx(FavouriteIcon, {
                size: 16
            }),
            "Favourite"
        ]
    });
};
/* harmony default export */ var favourite_cta = ((/* unused pure expression or super */ null && (favourite_cta_FavouriteCTA)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/index.ts









// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(58479);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(5438);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(42167);
// EXTERNAL MODULE: ../../../node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(92949);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/components/vehicle-image-carousel/vehicle-image-carousel.tsx












core_class/* default.use */.Z.use([
    a11y/* default */.Z,
    navigation/* default */.Z,
    pagination/* default */.Z
]);
const handleNavigateButtonClicked = (direction)=>()=>{
        sendDigitalDataEvent({
            event: {
                name: "click",
                category: "gallery navigate",
                label: "click",
                action: direction
            }
        });
        datadogRum.addAction(Actions.CLICK_MULTIPLE_NAV_IMAGE_BUTTON, {
            service: Context.SEARCH_MULTIPLE_IMAGES,
            squad: Context.SQUAD,
            direction
        });
    };
const handleCarouselImageViewed = (images, index)=>{
    const imageTitle = images[index].title;
    sendDigitalDataEvent({
        event: {
            name: "load",
            category: "thumbnail gallery",
            label: imageTitle,
            action: index + 1
        }
    });
    datadogRum.addAction(Actions.VIEWED_MULTIPLE_VEHICLE_CARD_IMAGE, {
        service: Context.SEARCH_MULTIPLE_IMAGES,
        squad: Context.SQUAD,
        label: imageTitle,
        imageIndex: index
    });
};
const handleCarouselImageClicked = (images, index)=>{
    const imageTitle = images[index].title;
    datadogRum.addAction(Actions.CLICK_MULTIPLE_VEHICLE_CARD_IMAGE, {
        service: Context.SEARCH_MULTIPLE_IMAGES,
        squad: Context.SQUAD,
        label: imageTitle,
        imageIndex: index
    });
};
function vehicle_image_carousel_VehicleImageCarousel({ images , isPending , isAvailable , productDetailUrl , ctaTitle , imageWithMorePhotosCta: imageTitleWithMorePhotosCta , imagesToDisplay: imageTitlesFilter  }) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const paginationRef = useRef(null);
    const [isFirstImageLoaded, setIsFirstImageLoaded] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const imagesToShow = imageTitlesFilter ? images.filter((image)=>imageTitlesFilter.includes(image.title)) : images;
    useEffect(()=>{
        setIsInitialLoad(false);
    }, []);
    const renderCarouselItem = ({ url , title  }, index)=>/*#__PURE__*/ _jsx(SwiperSlide, {
            "aria-roledescription": "slide",
            tag: "div",
            className: styles.carouselSlide,
            children: /*#__PURE__*/ _jsxs("a", {
                "data-testid": `pdp-url-${index}`,
                href: productDetailUrl,
                "aria-label": `${ctaTitle} ${title}`,
                onClick: ()=>handleCarouselImageClicked(images, index),
                children: [
                    !isFirstImageLoaded ? /*#__PURE__*/ _jsx(HoldingImage, {
                        isAvailable: isAvailable,
                        className: styles.holdingImage
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.carouselImageWrapper,
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                src: url,
                                width: 391,
                                height: 220,
                                alt: title,
                                className: cx(styles.carouselImage, !isFirstImageLoaded && styles.hidden),
                                onLoadingComplete: index === 0 ? ()=>setIsFirstImageLoaded(true) : undefined
                            }),
                            title === imageTitleWithMorePhotosCta ? /*#__PURE__*/ _jsx("div", {
                                className: cx(styles.morePhotosBackground, !isFirstImageLoaded && styles.hidden),
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: styles.morePhotosCTA,
                                    children: "More photos"
                                })
                            }) : null
                        ]
                    })
                ]
            })
        }, url);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.vehicleImageCarouselContainer,
        children: isPending ? /*#__PURE__*/ _jsx(HoldingImage, {}) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Swiper, {
                    className: styles.vehicleImageCarousel,
                    draggable: true,
                    wrapperTag: "div",
                    onSlideChange: (swiper)=>{
                        swiper.slides.forEach((slide, slideIndex)=>{
                            const isActiveSlide = slideIndex === swiper.activeIndex;
                            const ariaHidden = isActiveSlide ? "false" : "true";
                            slide.setAttribute("aria-hidden", ariaHidden);
                            const slideLink = slide.querySelector("a");
                            if (isActiveSlide) {
                                slideLink === null || slideLink === void 0 ? void 0 : slideLink.removeAttribute("tabindex");
                            } else {
                                slideLink === null || slideLink === void 0 ? void 0 : slideLink.setAttribute("tabindex", "-1");
                            }
                        });
                    },
                    onSlideChangeTransitionEnd: (swiper)=>{
                        if (!isInitialLoad) {
                            handleCarouselImageViewed(images, swiper.realIndex);
                        }
                    },
                    a11y: {
                        slideLabelMessage: "Image {{index}} of {{slidesLength}}"
                    },
                    navigation: {
                        nextEl: nextRef.current,
                        prevEl: prevRef.current
                    },
                    pagination: {
                        el: paginationRef.current,
                        bulletClass: styles.carouselBullet,
                        bulletActiveClass: styles.carouselBulletActive,
                        renderBullet: (index, className)=>`<li class="${className}">${index + 1}</li>`
                    },
                    loop: true,
                    "aria-label": "car images",
                    "aria-roledescription": "carousel",
                    "aria-atomic": "false",
                    "aria-live": "polite",
                    children: imagesToShow.map((image, index)=>renderCarouselItem(image, index))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: cx(styles.carouselNav, !isFirstImageLoaded && styles.hidden),
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: styles.carouselNavButton,
                            ref: prevRef,
                            "aria-label": "Previous image",
                            onClick: handleNavigateButtonClicked("backward"),
                            children: /*#__PURE__*/ _jsx(SvgIcon, {
                                name: "chevron-left",
                                color: "pureWhite",
                                size: 24,
                                className: styles.carouselNavIcon
                            })
                        }),
                        /*#__PURE__*/ _jsx("ul", {
                            className: styles.paginationIndicators,
                            "aria-hidden": "true",
                            ref: paginationRef
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: styles.carouselNavButton,
                            ref: nextRef,
                            "aria-label": "Next image",
                            onClick: handleNavigateButtonClicked("forward"),
                            children: /*#__PURE__*/ _jsx(SvgIcon, {
                                name: "chevron-right",
                                color: "pureWhite",
                                size: 24,
                                className: styles.carouselNavIcon
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/utils/product-detail-url/product-detail-url.ts

const product_detail_url_productDetailUrl = (vehicle)=>{
    if (!vehicle || !vehicle.make || !vehicle.model || !vehicle.id) {
        return "/used-cars";
    }
    return `/used-cars/${sanitisePathSegment(vehicle.make)}/${sanitisePathSegment(vehicle.model)}/details/${vehicle.id}`;
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/utils/product-detail-url/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/utils/send-favourites-analytic-event/events.ts

const saveVehicleEvent = (context)=>{
    return {
        event: {
            name: "logged-in-favourite",
            category: "button",
            action: "favourite",
            label: "logged in"
        },
        product: [
            {
                vehicle: {
                    ...context === null || context === void 0 ? void 0 : context.vehicle
                }
            }
        ]
    };
};
const unSaveVehicleEvent = (context)=>{
    return {
        event: {
            name: "logged-in-unfavourite",
            category: "button",
            action: "unfavourite",
            label: "logged in"
        },
        product: [
            {
                vehicle: {
                    ...context === null || context === void 0 ? void 0 : context.vehicle
                }
            }
        ]
    };
};
const unAuthSaveVehicleEvent = (context)=>{
    return {
        event: {
            name: "logged-out-favourite",
            category: "button",
            action: "favourite",
            label: "logged out"
        },
        product: [
            {
                vehicle: {
                    ...context === null || context === void 0 ? void 0 : context.vehicle
                }
            }
        ]
    };
};
const sendSaveVehicleEvent = (context)=>sendDigitalDataEvent(saveVehicleEvent(context));
const sendUnSaveVehicleEvent = (context)=>sendDigitalDataEvent(unSaveVehicleEvent(context));
const sendUnAuthSaveVehicleEvent = (context)=>sendDigitalDataEvent(unAuthSaveVehicleEvent(context));
const events_sendFavouritesAnalyticEvent = (isSignedIn, isSaved, context)=>{
    const signedInUnSavingVehicle = isSaved && isSignedIn;
    const signedInSavingVehicle = !isSaved && isSignedIn;
    const unAuthSavingVehicle = !isSaved && !isSignedIn;
    if (signedInSavingVehicle) sendSaveVehicleEvent(context);
    if (signedInUnSavingVehicle) sendUnSaveVehicleEvent(context);
    if (unAuthSavingVehicle) sendUnAuthSaveVehicleEvent(context);
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/utils/send-favourites-analytic-event/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/utils/index.ts




;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/vehicle-card.tsx


















const CompareCTA = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6965).then(__webpack_require__.bind(__webpack_require__, 96965)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(96965)
            ]
    },
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(96965)
            ]
    },
    ssr: false
});
const ERROR_MESSAGE = "Image Unavailable";
const vehicle_card_penceToPounds = (n)=>`${Math.round(n / 100).toFixed(0)}`;
const VehicleCard = ({ id , image , imageStyles , title , subtitle , isPending =false , isUnfavourited , unavailable , hasBorder =true , isHoverable =true , isSearchPage =false , redirectsToFPA =true , onClick , onAdminFeesClick , favourites =[] , userStatus , ...vehicleData })=>{
    var ref;
    const { discountInPence , depositContributionInPence , make , model , modelYear , isAvailable , isReserved , fuelType , transmissionType , mileage , vehicleYear , price , priceIncludingAdminFee , quoteRegularPaymentInPence , quoteType , additionalImages  } = vehicleData;
    const hasAdminFeeComplianceBeenSet = readFromEnv(Env.AdminFeeCompliance) === "true";
    /**
   * isSaved is hardcoded and passed from above
   * onSave is not used within the parent
   * we have access to favourites at this level
   * we can set is saved here
   * onSave can also be handled at this level
   *
   * */ const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const { addFavourite , removeFavourite  } = useFavouritesStore();
    const { isDesktop  } = useResponsiveEnvironment();
    const isFavourited = favourites.find((favourite)=>favourite.vehicleId === id);
    const shouldShowCarsOnOffer = Boolean(discountInPence);
    const shouldShowDepositContribution = Boolean(depositContributionInPence);
    const productDetailsLink = productDetailUrl({
        make,
        model,
        id
    });
    const isSold = isAvailable === false;
    // #region Multiple images
    const isSearchMultipleImagesFlagEnabled = readFromEnv(Env.SearchMultipleImages) === "true";
    // Multiple images experiment v2 (multivariate test)
    const searchMultipleImagesV2ExperienceId = (ref = useAdobeTarget("SEARCH_MULTIPLE_IMAGES_V2_EXPERIMENT_ID", true)) === null || ref === void 0 ? void 0 : ref.ExperienceId;
    const isSearchMultipleImagesV2Variant1 = searchMultipleImagesV2ExperienceId === "1";
    const isSearchMultipleImagesV2Variant2 = searchMultipleImagesV2ExperienceId === "2";
    // are we in an experience that requires the carousel?
    const isSearchMultipleImagesExperimentActive = isSearchMultipleImagesV2Variant1 || isSearchMultipleImagesV2Variant2;
    // only show the carousel if we're in an experiment, the feature flag is enabled,
    // and we actually have multiple images to display
    const shouldShowImageCarousel = isSearchMultipleImagesExperimentActive && isSearchMultipleImagesFlagEnabled && additionalImages && additionalImages.length > 1;
    // #endregion
    const tabTarget = isDesktop ? "_blank" : "_self";
    const relValue = isDesktop ? "opener" : undefined;
    const vehiclePrice = hasAdminFeeComplianceBeenSet ? priceIncludingAdminFee : price;
    const handleToggleFavourite = async ()=>{
        const messageToSend = {
            make,
            model,
            modelYear: Number(modelYear),
            vehicleId: id
        };
        if (isFavourited) {
            await removeFavourite(id);
            if (!isWindowUserAgentCinchApp) return;
            sendPostMessage("favouriteVehicleRemoved", messageToSend);
            datadogRum.addAction(Actions.CINCHAPP_POST_MESSAGE, {
                message: {
                    type: "favouriteVehicleRemoved",
                    data: messageToSend
                },
                service: Context.CINCHAPP,
                squad: Context.SQUAD
            });
            return;
        }
        await addFavourite(id);
        if (!isWindowUserAgentCinchApp) return;
        sendPostMessage("favouriteVehicleAdded", messageToSend);
        datadogRum.addAction(Actions.CINCHAPP_POST_MESSAGE, {
            message: {
                type: "favouriteVehicleAdded",
                data: messageToSend
            },
            service: Context.CINCHAPP,
            squad: Context.SQUAD
        });
    };
    const handleOnFavouriteClick = async ()=>{
        const pathnameWithSearchParams = `${window.location.pathname}${window.location.search}`;
        const vehicleId = (vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.vehicleId) ?? "";
        storePreAuthFavourite({
            id: vehicleId,
            url: pathnameWithSearchParams
        });
        sendFavouritesAnalyticEvent(userStatus === "valid", Boolean(isFavourited), {
            vehicle: vehicleData
        });
        if (userStatus === "valid") {
            await handleToggleFavourite();
        } else {
            setIsAuthModalOpen(true);
        }
    };
    const handleAuthModalClose = ()=>{
        setIsAuthModalOpen(false);
    };
    const handleOnClick = ()=>{
        datadogRum.addAction(Actions.VEHICLE_CARD_CLICKED);
        onClick && onClick();
    };
    return /*#__PURE__*/ _jsxs(Card, {
        "data-testid": "product-list-card",
        element: "article",
        hasBorder: hasBorder,
        isHoverable: isHoverable,
        isSearchPage: isSearchPage,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles["content"],
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: cx(styles["meta"], styles["hasAdminFees"], {
                            [styles["collapsed"]]: !hasBorder,
                            [styles["pending"]]: isPending && isSearchPage
                        }),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx(Title, {
                                        element: "h3",
                                        className: styles["title"],
                                        fontSizeFixed: "m",
                                        type: "cardTitle",
                                        isPending: isPending,
                                        "aria-describedby": isReserved ? `vehicle-reserved-${id}` : undefined,
                                        children: redirectsToFPA ? /*#__PURE__*/ _jsxs("a", {
                                            "data-testid": "product-list-card-link",
                                            href: productDetailsLink,
                                            className: styles["link"],
                                            onClick: handleOnClick,
                                            target: tabTarget,
                                            rel: relValue,
                                            children: [
                                                title,
                                                /*#__PURE__*/ _jsxs("noscript", {
                                                    children: [
                                                        " ",
                                                        subtitle
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ _jsxs(Text, {
                                            "data-testid": "product-list-card-text",
                                            children: [
                                                title,
                                                /*#__PURE__*/ _jsxs("noscript", {
                                                    children: [
                                                        " ",
                                                        subtitle
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Subtitle, {
                                        isPending: isPending,
                                        fontSize: "s",
                                        className: styles["subtitle"],
                                        children: parseVehicleDoorTrim(subtitle)
                                    }),
                                    /*#__PURE__*/ _jsx(SpecsList, {
                                        isPending: isPending,
                                        listStyleClassName: styles["specsList"],
                                        listItemClassName: styles["specsListItem"],
                                        items: formatVehicleSpecs({
                                            fuelType,
                                            transmissionType,
                                            mileage,
                                            modelYear: Number(vehicleYear || modelYear)
                                        })
                                    })
                                ]
                            }),
                            !!vehiclePrice && /*#__PURE__*/ _jsx(Price, {
                                isPending: isPending,
                                price: vehiclePrice,
                                quoteRegularPaymentInPence: quoteRegularPaymentInPence,
                                quoteType: quoteType,
                                discountInPence: discountInPence,
                                shouldShowCarsOnOfferTag: shouldShowCarsOnOffer,
                                shouldShowDepositContribution: shouldShowDepositContribution,
                                vehicleId: id,
                                onAdminFeesClick: onAdminFeesClick
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["searchActions"],
                        children: [
                            /*#__PURE__*/ _jsx(CompareCTA, {
                                vehicleId: id,
                                vehicleTitle: title,
                                vehicleImage: image,
                                vehicleMake: make,
                                vehicleModel: model
                            }),
                            /*#__PURE__*/ _jsx(FavouriteCTA, {
                                isPending: isPending,
                                isSaved: favourites.some((vehicle)=>vehicle.vehicleId === id),
                                onClick: handleOnFavouriteClick
                            }),
                            /*#__PURE__*/ _jsx(AuthModal, {
                                isOpen: isAuthModalOpen,
                                handleClose: handleAuthModalClose,
                                useBrowserNavigation: true,
                                vehicleImage: image
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cx(styles["imageContainer"], imageStyles, {
                    [styles["imageContainerCollapsed"]]: !hasBorder
                }),
                children: [
                    shouldShowImageCarousel ? /*#__PURE__*/ _jsx(VehicleImageCarousel, {
                        images: additionalImages,
                        isPending: isPending,
                        isAvailable: isAvailable,
                        productDetailUrl: productDetailsLink,
                        ctaTitle: title,
                        imageWithMorePhotosCta: isSearchMultipleImagesV2Variant1 ? "Boot" : undefined,
                        imagesToDisplay: isSearchMultipleImagesV2Variant2 ? [
                            "Front driver side",
                            "Interior front"
                        ] : undefined
                    }) : /*#__PURE__*/ _jsx(ProductImage, {
                        alt: "",
                        isAvailable: isAvailable,
                        image: image,
                        unavailableImageMessage: isSold && " " || unavailable || ERROR_MESSAGE,
                        isPending: isPending
                    }),
                    shouldShowCarsOnOffer && !isReserved && !shouldShowDepositContribution && !isSold && /*#__PURE__*/ _jsx(Text, {
                        fontWeight: "semibold",
                        className: cx([
                            styles["badge"],
                            styles["discount"]
                        ]),
                        "data-testid": "vehicle-has-discount",
                        id: `vehicle-discount-${id}`,
                        children: `£${vehicle_card_penceToPounds(discountInPence ?? 0)} off`
                    }),
                    isSearchPage && shouldShowDepositContribution && !isReserved && !isSold && /*#__PURE__*/ _jsxs(Text, {
                        fontWeight: "semibold",
                        className: `${styles["badge"]} ${styles["deposit"]}`,
                        id: `vehicle-deposit-${id}`,
                        children: [
                            `£${vehicle_card_penceToPounds(depositContributionInPence ?? 0)}`,
                            " towards deposit ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "10.9% APR Representative"
                        ]
                    }),
                    isReserved && !isSold && /*#__PURE__*/ _jsx(Text, {
                        fontWeight: "book",
                        className: `${styles["badge"]} ${styles["reserved"]}`,
                        "data-testid": "vehicle-is-reserved",
                        id: `vehicle-reserved-${id}`,
                        children: isSearchMultipleImagesFlagEnabled ? "Reserved" : "Currently reserved"
                    }),
                    isSold && /*#__PURE__*/ _jsx(Text, {
                        element: "span",
                        fontSizeFixed: "s",
                        fontWeight: "book",
                        className: `${styles["badge"]} ${styles["sold"]}`,
                        "data-testid": "vehicle-is-sold",
                        id: `vehicle-sold-${id}`,
                        children: "Sold"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var vehicle_card = ((/* unused pure expression or super */ null && (VehicleCard)));

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/vehicle-card/index.ts


;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/mobile-app-footer/mobile-app-footer.tsx



const footerText = "Cinch Cars Limited is an appointed representative of ITC Compliance Limited which is authorised and regulated by the Financial Conduct Authority (their registration number is 313486). Permitted activities include acting as a credit broker not a lender. For further details visit cinch.co.uk. Representative APR 11.4%. Trade-in value of your car must be higher than outstanding finance amount. T&Cs & exclusions apply.";
const MobileAppFooter = ()=>/*#__PURE__*/ _jsx("footer", {
        className: styles.footerContainer,
        children: /*#__PURE__*/ _jsx(Text, {
            element: "p",
            fontSize: "s",
            fontWeight: "light",
            lineHeight: "body",
            children: footerText
        })
    });

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/mobile-app-footer/index.ts


// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/components/used-cars-data-temp-component/used-cars-data-temp-component.tsx



const UsedCarsDataTempComponent = ()=>{
    const { isValidating , isLoading , usedCarsApiError , searchResults , searchParams , setPageNumber , getUrlForPageNumber  } = useUsedCarsData();
    const currentPageNumber = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.pageNumber) ?? 1;
    const handlePageButtonClicked = (direction)=>()=>{
            const pageOffset = direction === "next" ? 1 : -1;
            setPageNumber(Math.max(1, currentPageNumber + pageOffset));
        };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            "useUsedCarsData hook testing - dev only",
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handlePageButtonClicked("prev"),
                        children: "Previous page"
                    }),
                    currentPageNumber,
                    /*#__PURE__*/ _jsx("button", {
                        onClick: handlePageButtonClicked("next"),
                        children: "Next page"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "searchParams: ",
                    /*#__PURE__*/ _jsx("pre", {
                        children: JSON.stringify(searchParams, null, 2)
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "isValidating: ",
                    isValidating ? "true" : "false"
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "isLoading: ",
                    isLoading ? "true" : "false"
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "usedCarsApiError: ",
                    /*#__PURE__*/ _jsx("pre", {
                        children: usedCarsApiError
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "Pages:",
                    /*#__PURE__*/ _jsx(Link, {
                        href: getUrlForPageNumber(1),
                        children: "1"
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: getUrlForPageNumber(2),
                        children: "2"
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: getUrlForPageNumber(3),
                        children: "3"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "searchResults: ",
                    /*#__PURE__*/ _jsx("pre", {
                        children: JSON.stringify(searchResults, null, 2)
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/search/shared/src/lib/context/ssr-props-context.tsx


const SsrPropsContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(undefined)));
const SsrPropsContextProvider = ({ children , isSsrUserAgentCinchApp  })=>/*#__PURE__*/ _jsx(SsrPropsContext.Provider, {
        value: {
            isSsrUserAgentCinchApp
        },
        children: children
    });
const useSsrProps = ()=>{
    const context = useContext(SsrPropsContext);
    if (context === undefined) {
        throw new Error("useSsrPropsContext must be used within a SsrPropsContextProvider");
    }
    return context;
};


;// CONCATENATED MODULE: ../../../libs/search/shared/src/index.ts
// Hooks

// Utils


// Components






// Context




/***/ })

}]);